// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options_3,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AcceptPrivacyPolicyData,
  AcceptPrivacyPolicyErrors,
  AcceptPrivacyPolicyResponses,
  AcceptTermsData,
  AcceptTermsErrors,
  AcceptTermsResponses,
  AddTeamMemberData,
  AddTeamMemberErrors,
  AddTeamMemberResponses,
  ApplyForJobData,
  ApplyForJobErrors,
  ApplyForJobResponses,
  ApplyPlannerSessionData,
  ApplyPlannerSessionErrors,
  ApplyPlannerSessionResponses,
  ApplyPlanOperationData,
  ApplyPlanOperationErrors,
  ApplyPlanOperationResponses,
  ArchiveJobData,
  ArchiveJobErrors,
  ArchiveJobResponses,
  BookingUnsubscribeData,
  BookingUnsubscribeErrors,
  BookingUnsubscribeResponses,
  BookingWithdrawData,
  BookingWithdrawErrors,
  BookingWithdrawResponses,
  BookSlotData,
  BookSlotErrors,
  BookSlotResponses,
  BulkAssessmentIntakeData,
  BulkAssessmentIntakeErrors,
  BulkAssessmentIntakeResponses,
  BulkInterviewIntakeData,
  BulkInterviewIntakeErrors,
  BulkInterviewIntakeResponses,
  BulkScreeningIntakeData,
  BulkScreeningIntakeErrors,
  BulkScreeningIntakeResponses,
  CheckAlreadyInSystemData,
  CheckAlreadyInSystemErrors,
  CheckAlreadyInSystemResponses,
  CheckSimulationAssertionsData,
  CheckSimulationAssertionsErrors,
  CheckSimulationAssertionsResponses,
  CompleteCodingAssessmentData,
  CompleteCodingAssessmentErrors,
  CompleteCodingAssessmentResponses,
  CompleteCopilotGuideItemData,
  CompleteCopilotGuideItemErrors,
  CompleteCopilotGuideItemResponses,
  CompletePrescreenConversationData,
  CompletePrescreenConversationErrors,
  CompletePrescreenConversationResponses,
  CreateApplicationQuestionData,
  CreateApplicationQuestionErrors,
  CreateApplicationQuestionResponses,
  CreateCodingAssessmentRecordingSessionData,
  CreateCodingAssessmentRecordingSessionErrors,
  CreateCodingAssessmentRecordingSessionResponses,
  CreateCopilotRoundData,
  CreateCopilotRoundErrors,
  CreateCopilotRoundResponses,
  CreateInterviewPlanData,
  CreateInterviewPlanErrors,
  CreateInterviewPlanResponses,
  CreateJobData,
  CreateJobErrors,
  CreateJobResponses,
  CreatePartnerCredentialData,
  CreatePartnerCredentialErrors,
  CreatePartnerCredentialResponses,
  CreateScreenerPlanData,
  CreateScreenerPlanErrors,
  CreateScreenerPlanResponses,
  CreateTenantData,
  CreateTenantErrors,
  CreateTenantResponses,
  DecidePlannerSessionData,
  DecidePlannerSessionErrors,
  DecidePlannerSessionResponses,
  DeleteApplicationCandidateData,
  DeleteApplicationCandidateErrors,
  DeleteApplicationCandidateResponses,
  DeleteApplicationQuestionData,
  DeleteApplicationQuestionErrors,
  DeleteApplicationQuestionResponses,
  DeleteDocumentData,
  DeleteDocumentErrors,
  DeleteDocumentResponses,
  EditPlannerSessionData,
  EditPlannerSessionErrors,
  EditPlannerSessionResponses,
  EvaluateScreenerApplicationData,
  EvaluateScreenerApplicationErrors,
  EvaluateScreenerApplicationResponses,
  EvaluateScreenerJobData,
  EvaluateScreenerJobErrors,
  EvaluateScreenerJobResponses,
  ExecuteTaskTasksExecutePostData,
  ExecuteTaskTasksExecutePostErrors,
  ExecuteTaskTasksExecutePostResponses,
  ExpandJobDescriptionData,
  ExpandJobDescriptionErrors,
  ExpandJobDescriptionResponses,
  ExportApplicationsData,
  ExportApplicationsErrors,
  ExportApplicationsResponses,
  ExportBoardData,
  ExportBoardErrors,
  ExportBoardResponses,
  ExportScreenerPlansData,
  ExportScreenerPlansErrors,
  ExportScreenerPlansResponses,
  ForceReleasePrescreenConversationData,
  ForceReleasePrescreenConversationErrors,
  ForceReleasePrescreenConversationResponses,
  GenerateInkeepTokenData,
  GenerateInkeepTokenErrors,
  GenerateInkeepTokenResponses,
  GenerateInteractiveProblemData,
  GenerateInteractiveProblemErrors,
  GenerateInteractiveProblemResponses,
  GenerateInterviewPlanRubricData,
  GenerateInterviewPlanRubricErrors,
  GenerateInterviewPlanRubricResponses,
  GenerateInterviewShareTokenData,
  GenerateInterviewShareTokenErrors,
  GenerateInterviewShareTokenResponses,
  GenerateScreenerShareTokenData,
  GenerateScreenerShareTokenErrors,
  GenerateScreenerShareTokenResponses,
  GenerateSectionCriteriaData,
  GenerateSectionCriteriaErrors,
  GenerateSectionCriteriaResponses,
  GenerateSimulationPersonaData,
  GenerateSimulationPersonaErrors,
  GenerateSimulationPersonaResponses,
  GetActiveEmailTemplateData,
  GetActiveEmailTemplateErrors,
  GetActiveEmailTemplateResponses,
  GetApplicationCopilotRoundData,
  GetApplicationCopilotRoundErrors,
  GetApplicationCopilotRoundResponses,
  GetApplicationData,
  GetApplicationErrors,
  GetApplicationPhotoData,
  GetApplicationPhotoErrors,
  GetApplicationPhotoImageData,
  GetApplicationPhotoImageErrors,
  GetApplicationPhotoImageResponses,
  GetApplicationPhotoResponses,
  GetApplicationPhotoVersionsData,
  GetApplicationPhotoVersionsErrors,
  GetApplicationPhotoVersionsResponses,
  GetApplicationQuestionsData,
  GetApplicationQuestionsErrors,
  GetApplicationQuestionsResponses,
  GetApplicationResponses,
  GetAssessmentApplicationsData,
  GetAssessmentApplicationsErrors,
  GetAssessmentApplicationsResponses,
  GetAssessmentAttemptData,
  GetAssessmentAttemptErrors,
  GetAssessmentAttemptRecordingUrlData,
  GetAssessmentAttemptRecordingUrlErrors,
  GetAssessmentAttemptRecordingUrlResponses,
  GetAssessmentAttemptResponses,
  GetAssessmentConfigData,
  GetAssessmentConfigErrors,
  GetAssessmentConfigResponses,
  GetAssessmentRecordingUrlData,
  GetAssessmentRecordingUrlErrors,
  GetAssessmentRecordingUrlResponses,
  GetBoardExportOptionsData,
  GetBoardExportOptionsErrors,
  GetBoardExportOptionsResponses,
  GetBoardRowData,
  GetBoardRowErrors,
  GetBoardRowResponses,
  GetBoardSummaryData,
  GetBoardSummaryErrors,
  GetBoardSummaryResponses,
  GetBookingConfigData,
  GetBookingConfigErrors,
  GetBookingConfigResponses,
  GetBookingIcsData,
  GetBookingIcsErrors,
  GetBookingIcsResponses,
  GetBookingSlotsData,
  GetBookingSlotsErrors,
  GetBookingSlotsResponses,
  GetBookingStatusData,
  GetBookingStatusErrors,
  GetBookingStatusResponses,
  GetCachedSectionsData,
  GetCachedSectionsErrors,
  GetCachedSectionsResponses,
  GetCandidateIntakeValidationStatusData,
  GetCandidateIntakeValidationStatusErrors,
  GetCandidateIntakeValidationStatusResponses,
  GetCandidateInterviewData,
  GetCandidateInterviewErrors,
  GetCandidateInterviewResponses,
  GetCodingAssessmentExecutionStatusData,
  GetCodingAssessmentExecutionStatusErrors,
  GetCodingAssessmentExecutionStatusResponses,
  GetCodingAssessmentPreviewData,
  GetCodingAssessmentPreviewErrors,
  GetCodingAssessmentPreviewResponses,
  GetCodingAssessmentProblemAssetData,
  GetCodingAssessmentProblemAssetErrors,
  GetCodingAssessmentProblemAssetResponses,
  GetConsumptionReportData,
  GetConsumptionReportErrors,
  GetConsumptionReportResponses,
  GetCopilotFeedbackData,
  GetCopilotFeedbackErrors,
  GetCopilotFeedbackResponses,
  GetCopilotRoundData,
  GetCopilotRoundErrors,
  GetCopilotRoundResponses,
  GetCopilotTranscriptData,
  GetCopilotTranscriptErrors,
  GetCopilotTranscriptResponses,
  GetCurrentTenantData,
  GetCurrentTenantErrors,
  GetCurrentTenantPublicData,
  GetCurrentTenantPublicErrors,
  GetCurrentTenantPublicResponses,
  GetCurrentTenantResponses,
  GetCurrentUserData,
  GetCurrentUserErrors,
  GetCurrentUserResponses,
  GetDocumentContentData,
  GetDocumentContentErrors,
  GetDocumentContentResponses,
  GetDocumentDownloadUrlData,
  GetDocumentDownloadUrlErrors,
  GetDocumentDownloadUrlResponses,
  GetEmailTemplateData,
  GetEmailTemplateErrors,
  GetEmailTemplateResponses,
  GetEmailTemplateVariablesData,
  GetEmailTemplateVariablesErrors,
  GetEmailTemplateVariablesResponses,
  GetExportOptionsData,
  GetExportOptionsErrors,
  GetExportOptionsResponses,
  GetGreenhouseMetadataData,
  GetGreenhouseMetadataErrors,
  GetGreenhouseMetadataResponses,
  GetInterviewingCountsData,
  GetInterviewingCountsErrors,
  GetInterviewingCountsResponses,
  GetInterviewPlanData,
  GetInterviewPlanDraftData,
  GetInterviewPlanDraftErrors,
  GetInterviewPlanDraftResponses,
  GetInterviewPlanErrors,
  GetInterviewPlanResponses,
  GetInterviewPlanRubricData,
  GetInterviewPlanRubricErrors,
  GetInterviewPlanRubricResponses,
  GetInterviewResultData,
  GetInterviewResultErrors,
  GetInterviewResultResponses,
  GetJobAnalyticsBatchesData,
  GetJobAnalyticsBatchesErrors,
  GetJobAnalyticsBatchesResponses,
  GetJobAnalyticsData,
  GetJobAnalyticsErrors,
  GetJobAnalyticsExcelData,
  GetJobAnalyticsExcelErrors,
  GetJobAnalyticsExcelResponses,
  GetJobAnalyticsResponses,
  GetJobApplicationQuestionsData,
  GetJobApplicationQuestionsErrors,
  GetJobApplicationQuestionsResponses,
  GetJobData,
  GetJobErrors,
  GetJobLoginContextData,
  GetJobLoginContextErrors,
  GetJobLoginContextResponses,
  GetJobResponses,
  GetListingFilterOptionsData,
  GetListingFilterOptionsErrors,
  GetListingFilterOptionsResponses,
  GetMyCopilotRoundData,
  GetMyCopilotRoundErrors,
  GetMyCopilotRoundResponses,
  GetMyJobData,
  GetMyJobErrors,
  GetMyJobResponses,
  GetMyPermissionsData,
  GetMyPermissionsErrors,
  GetMyPermissionsResponses,
  GetPartnerCredentialByKeyIdData,
  GetPartnerCredentialByKeyIdErrors,
  GetPartnerCredentialByKeyIdResponses,
  GetPartnerCredentialData,
  GetPartnerCredentialErrors,
  GetPartnerCredentialResponses,
  GetPlannerSessionData,
  GetPlannerSessionErrors,
  GetPlannerSessionResponses,
  GetPlannerTurnsData,
  GetPlannerTurnsErrors,
  GetPlannerTurnsResponses,
  GetPrescreenConversationData,
  GetPrescreenConversationDetailData,
  GetPrescreenConversationDetailErrors,
  GetPrescreenConversationDetailResponses,
  GetPrescreenConversationErrors,
  GetPrescreenConversationResponses,
  GetPrescreenConversationsData,
  GetPrescreenConversationsErrors,
  GetPrescreenConversationsResponses,
  GetProblemBankAssetData,
  GetProblemBankAssetErrors,
  GetProblemBankAssetResponses,
  GetProblemTopicsData,
  GetProblemTopicsErrors,
  GetProblemTopicsResponses,
  GetProctoringClipUrlData,
  GetProctoringClipUrlErrors,
  GetProctoringClipUrlResponses,
  GetPublicJobData,
  GetPublicJobErrors,
  GetPublicJobResponses,
  GetPublicScreenerApplicationData,
  GetPublicScreenerApplicationErrors,
  GetPublicScreenerApplicationResponses,
  GetRecruiterInterviewData,
  GetRecruiterInterviewErrors,
  GetRecruiterInterviewResponses,
  GetScreenerPlanData,
  GetScreenerPlanErrors,
  GetScreenerPlanResponses,
  GetScreeningApplicationData,
  GetScreeningApplicationErrors,
  GetScreeningApplicationResponses,
  GetScreeningApplicationsData,
  GetScreeningApplicationsErrors,
  GetScreeningApplicationsResponses,
  GetSectionTimeLimitsData,
  GetSectionTimeLimitsErrors,
  GetSectionTimeLimitsResponses,
  GetSharedAssessmentRecordingUrlData,
  GetSharedAssessmentRecordingUrlErrors,
  GetSharedAssessmentRecordingUrlResponses,
  GetSharedAssessmentResultData,
  GetSharedAssessmentResultErrors,
  GetSharedAssessmentResultResponses,
  GetSimulationData,
  GetSimulationErrors,
  GetSimulationPersonaData,
  GetSimulationPersonaErrors,
  GetSimulationPersonaResponses,
  GetSimulationResponses,
  GetSimulationTranscriptData,
  GetSimulationTranscriptErrors,
  GetSimulationTranscriptResponses,
  GetTenantByIdData,
  GetTenantByIdErrors,
  GetTenantByIdResponses,
  GetUsageAnalyticsData,
  GetUsageAnalyticsErrors,
  GetUsageAnalyticsResponses,
  GetWorkflowAuditHistoryData,
  GetWorkflowAuditHistoryErrors,
  GetWorkflowAuditHistoryResponses,
  GetWorkflowAvailableEventsData,
  GetWorkflowAvailableEventsErrors,
  GetWorkflowAvailableEventsResponses,
  GetWorkflowBulkAvailableEventsData,
  GetWorkflowBulkAvailableEventsErrors,
  GetWorkflowBulkAvailableEventsResponses,
  GlobalCandidateSearchData,
  GlobalCandidateSearchErrors,
  GlobalCandidateSearchResponses,
  GreenhouseListTestsData,
  GreenhouseListTestsErrors,
  GreenhouseListTestsResponses,
  GreenhouseRequestErrorsData,
  GreenhouseRequestErrorsErrors,
  GreenhouseRequestErrorsResponses,
  GreenhouseSendTestData,
  GreenhouseSendTestErrors,
  GreenhouseSendTestResponses,
  GreenhouseTestStatusData,
  GreenhouseTestStatusErrors,
  GreenhouseTestStatusResponses,
  InviteTenantMemberData,
  InviteTenantMemberErrors,
  InviteTenantMemberResponses,
  InviteToAssessmentData,
  InviteToAssessmentErrors,
  InviteToAssessmentResponses,
  InviteToInterviewData,
  InviteToInterviewErrors,
  InviteToInterviewResponses,
  ListApplicationsData,
  ListApplicationsErrors,
  ListApplicationsResponses,
  ListBoardData,
  ListBoardErrors,
  ListBoardResponses,
  ListCodingAssessmentSubmissionsData,
  ListCodingAssessmentSubmissionsErrors,
  ListCodingAssessmentSubmissionsResponses,
  ListCopilotRoundsData,
  ListCopilotRoundsErrors,
  ListCopilotRoundsResponses,
  ListDocumentsData,
  ListDocumentsErrors,
  ListDocumentsResponses,
  ListEmailTemplatesData,
  ListEmailTemplatesErrors,
  ListEmailTemplatesResponses,
  ListInterviewingApplicationsData,
  ListInterviewingApplicationsErrors,
  ListInterviewingApplicationsResponses,
  ListInterviewPlansData,
  ListInterviewPlansErrors,
  ListInterviewPlansResponses,
  ListInterviewsForJobData,
  ListInterviewsForJobErrors,
  ListInterviewsForJobResponses,
  ListJobsData,
  ListJobsErrors,
  ListJobsResponses,
  ListMyCopilotRoundsData,
  ListMyCopilotRoundsErrors,
  ListMyCopilotRoundsResponses,
  ListMyInterviewsData,
  ListMyInterviewsErrors,
  ListMyInterviewsResponses,
  ListMyJobsData,
  ListMyJobsErrors,
  ListMyJobsResponses,
  ListPendingBookingInvitesData,
  ListPendingBookingInvitesErrors,
  ListPendingBookingInvitesResponses,
  ListPublicJobsData,
  ListPublicJobsErrors,
  ListPublicJobsResponses,
  ListSimulationPersonasData,
  ListSimulationPersonasResponses,
  ListSimulationsData,
  ListSimulationsErrors,
  ListSimulationsResponses,
  ListTeamMembersData,
  ListTeamMembersErrors,
  ListTeamMembersResponses,
  ListTenantMembersData,
  ListTenantMembersErrors,
  ListTenantMembersResponses,
  ListTenantRolesData,
  ListTenantRolesErrors,
  ListTenantRolesResponses,
  ListTenantsData,
  ListTenantsErrors,
  ListTenantsResponses,
  MarkCodingAssessmentEditorLoadedData,
  MarkCodingAssessmentEditorLoadedErrors,
  MarkCodingAssessmentEditorLoadedResponses,
  MarkCopilotRoundNoShowData,
  MarkCopilotRoundNoShowErrors,
  MarkCopilotRoundNoShowResponses,
  MigratePlannerSessionData,
  MigratePlannerSessionErrors,
  MigratePlannerSessionResponses,
  ParseCandidateResumeData,
  ParseCandidateResumeErrors,
  ParseCandidateResumeResponses,
  PreviewSampleProblemsData,
  PreviewSampleProblemsErrors,
  PreviewSampleProblemsResponses,
  PronounceWithTenantVoiceData,
  PronounceWithTenantVoiceErrors,
  PronounceWithTenantVoiceResponses,
  PublishJobData,
  PublishJobErrors,
  PublishJobResponses,
  QuestionGeneratorLlmData,
  QuestionGeneratorLlmErrors,
  QuestionGeneratorLlmResponses,
  RecheckSimulationData,
  RecheckSimulationErrors,
  RecheckSimulationResponses,
  RecordCodingAssessmentEventsData,
  RecordCodingAssessmentEventsErrors,
  RecordCodingAssessmentEventsResponses,
  RecordConnectionQualityData,
  RecordConnectionQualityErrors,
  RecordConnectionQualityResponses,
  RecordGreenhouseMetadataData,
  RecordGreenhouseMetadataErrors,
  RecordGreenhouseMetadataResponses,
  RecordProctoringFeedbackData,
  RecordProctoringFeedbackErrors,
  RecordProctoringFeedbackResponses,
  RefineCopilotGuideData,
  RefineCopilotGuideErrors,
  RefineCopilotGuideResponses,
  RefineJdSelectionData,
  RefineJdSelectionErrors,
  RefineJdSelectionResponses,
  RefineJobDescriptionData,
  RefineJobDescriptionErrors,
  RefineJobDescriptionResponses,
  RefreshSentEmailsData,
  RefreshSentEmailsErrors,
  RefreshSentEmailsResponses,
  RegenerateCaseStudyData,
  RegenerateCaseStudyErrors,
  RegenerateCaseStudyResponses,
  RegenerateCopilotGuideData,
  RegenerateCopilotGuideErrors,
  RegenerateCopilotGuideResponses,
  RemoveTeamMemberData,
  RemoveTeamMemberErrors,
  RemoveTeamMemberResponses,
  RemoveTenantMemberData,
  RemoveTenantMemberErrors,
  RemoveTenantMemberResponses,
  RequestRescheduleData,
  RequestRescheduleErrors,
  RequestRescheduleResponses,
  RescheduleCopilotRoundData,
  RescheduleCopilotRoundErrors,
  RescheduleCopilotRoundResponses,
  ResolveSimulationPersonaData,
  ResolveSimulationPersonaErrors,
  ResolveSimulationPersonaResponses,
  RestoreDeclinedData,
  RestoreDeclinedErrors,
  RestoreDeclinedResponses,
  ResumePlannerSessionData,
  ResumePlannerSessionErrors,
  ResumePlannerSessionResponses,
  ReviewRescheduleData,
  ReviewRescheduleErrors,
  ReviewRescheduleResponses,
  RevokePartnerCredentialByKeyIdData,
  RevokePartnerCredentialByKeyIdErrors,
  RevokePartnerCredentialByKeyIdResponses,
  RevokePartnerCredentialData,
  RevokePartnerCredentialErrors,
  RevokePartnerCredentialResponses,
  RunCodingAssessmentCodeData,
  RunCodingAssessmentCodeErrors,
  RunCodingAssessmentCodeResponses,
  SaveAssessmentConfigData,
  SaveAssessmentConfigErrors,
  SaveAssessmentConfigResponses,
  SaveAssessmentRequirementsData,
  SaveAssessmentRequirementsErrors,
  SaveAssessmentRequirementsResponses,
  SaveCopilotFeedbackData,
  SaveCopilotFeedbackErrors,
  SaveCopilotFeedbackResponses,
  SaveInterviewPlanDraftData,
  SaveInterviewPlanDraftErrors,
  SaveInterviewPlanDraftResponses,
  ScheduleCopilotRoundData,
  ScheduleCopilotRoundErrors,
  ScheduleCopilotRoundResponses,
  SearchSentEmailsData,
  SearchSentEmailsErrors,
  SearchSentEmailsResponses,
  SendBookingInvitesData,
  SendBookingInvitesErrors,
  SendBookingInvitesResponses,
  SendCaseStudyChatMessageData,
  SendCaseStudyChatMessageErrors,
  SendCaseStudyChatMessageResponses,
  SendCopilotRoundInvitesData,
  SendCopilotRoundInvitesErrors,
  SendCopilotRoundInvitesResponses,
  SendTestEmailData,
  SendTestEmailErrors,
  SendTestEmailResponses,
  SetIntakeMetadataData,
  SetIntakeMetadataErrors,
  SetIntakeMetadataResponses,
  SetSelectionStatusData,
  SetSelectionStatusErrors,
  SetSelectionStatusResponses,
  SingleAssessmentIntakeData,
  SingleAssessmentIntakeErrors,
  SingleAssessmentIntakeResponses,
  SingleCopilotIntakeData,
  SingleCopilotIntakeErrors,
  SingleCopilotIntakeResponses,
  SingleInterviewIntakeData,
  SingleInterviewIntakeErrors,
  SingleInterviewIntakeResponses,
  SingleScreeningIntakeData,
  SingleScreeningIntakeErrors,
  SingleScreeningIntakeResponses,
  StartCandidateIntakeValidationData,
  StartCandidateIntakeValidationErrors,
  StartCandidateIntakeValidationResponses,
  StartCodingAssessmentData,
  StartCodingAssessmentErrors,
  StartCodingAssessmentResponses,
  StartCopilotListeningData,
  StartCopilotListeningErrors,
  StartCopilotListeningResponses,
  StartJobDesignGenerationData,
  StartJobDesignGenerationErrors,
  StartJobDesignGenerationResponses,
  StartJobSetupGenerationData,
  StartJobSetupGenerationErrors,
  StartJobSetupGenerationResponses,
  StartPlannerSessionData,
  StartPlannerSessionErrors,
  StartPlannerSessionResponses,
  StartPrescreenConversationData,
  StartPrescreenConversationErrors,
  StartPrescreenConversationResponses,
  StartSimulationData,
  StartSimulationErrors,
  StartSimulationResponses,
  StopCopilotListeningData,
  StopCopilotListeningErrors,
  StopCopilotListeningResponses,
  SubmitApplicationAnswersData,
  SubmitApplicationAnswersErrors,
  SubmitApplicationAnswersResponses,
  SubmitCodingAssessmentCodeData,
  SubmitCodingAssessmentCodeErrors,
  SubmitCodingAssessmentCodeResponses,
  SuggestAssessmentDesignData,
  SuggestAssessmentDesignErrors,
  SuggestAssessmentDesignResponses,
  SuggestCopilotQuestionsData,
  SuggestCopilotQuestionsErrors,
  SuggestCopilotQuestionsResponses,
  SuggestCopilotStartData,
  SuggestCopilotStartErrors,
  SuggestCopilotStartResponses,
  SuggestInteractiveConfigData,
  SuggestInteractiveConfigErrors,
  SuggestInteractiveConfigResponses,
  SuggestQuestionsData,
  SuggestQuestionsErrors,
  SuggestQuestionsResponses,
  SuggestSubtopicsData,
  SuggestSubtopicsErrors,
  SuggestSubtopicsResponses,
  SuggestTopicsData,
  SuggestTopicsErrors,
  SuggestTopicsResponses,
  SyncCodingAssessmentDraftData,
  SyncCodingAssessmentDraftErrors,
  SyncCodingAssessmentDraftResponses,
  UnpublishJobData,
  UnpublishJobErrors,
  UnpublishJobResponses,
  UpdateApplicationQuestionData,
  UpdateApplicationQuestionErrors,
  UpdateApplicationQuestionResponses,
  UpdateAssessmentAiProctoringData,
  UpdateAssessmentAiProctoringErrors,
  UpdateAssessmentAiProctoringResponses,
  UpdateAssessmentInstructionsData,
  UpdateAssessmentInstructionsErrors,
  UpdateAssessmentInstructionsResponses,
  UpdateAssessmentLiveProctoringData,
  UpdateAssessmentLiveProctoringErrors,
  UpdateAssessmentLiveProctoringResponses,
  UpdateCopilotGuideData,
  UpdateCopilotGuideErrors,
  UpdateCopilotGuideResponses,
  UpdateCurrentTenantData,
  UpdateCurrentTenantErrors,
  UpdateCurrentTenantResponses,
  UpdateCurrentUserData,
  UpdateCurrentUserErrors,
  UpdateCurrentUserResponses,
  UpdateCustomInstructionsData,
  UpdateCustomInstructionsErrors,
  UpdateCustomInstructionsResponses,
  UpdateEmailTemplateData,
  UpdateEmailTemplateErrors,
  UpdateEmailTemplateResponses,
  UpdateInterviewPlanRubricData,
  UpdateInterviewPlanRubricErrors,
  UpdateInterviewPlanRubricResponses,
  UpdateJobData,
  UpdateJobErrors,
  UpdateJobResponses,
  UpdateJobSetupStateData,
  UpdateJobSetupStateErrors,
  UpdateJobSetupStateResponses,
  UpdateLiveProctoringData,
  UpdateLiveProctoringErrors,
  UpdateLiveProctoringResponses,
  UpdateOfflineProctoringData,
  UpdateOfflineProctoringErrors,
  UpdateOfflineProctoringResponses,
  UpdatePartnerCredentialWebhookByKeyIdData,
  UpdatePartnerCredentialWebhookByKeyIdErrors,
  UpdatePartnerCredentialWebhookByKeyIdResponses,
  UpdatePartnerCredentialWebhookData,
  UpdatePartnerCredentialWebhookErrors,
  UpdatePartnerCredentialWebhookResponses,
  UpdateScreenerPlanData,
  UpdateScreenerPlanErrors,
  UpdateScreenerPlanResponses,
  UpdateTeamMemberRoleData,
  UpdateTeamMemberRoleErrors,
  UpdateTeamMemberRoleResponses,
  UpdateTenantMemberRoleData,
  UpdateTenantMemberRoleErrors,
  UpdateTenantMemberRoleResponses,
  UploadApplicationPhotoData,
  UploadApplicationPhotoErrors,
  UploadApplicationPhotoResponses,
  UploadJobDescriptionData,
  UploadJobDescriptionErrors,
  UploadJobDescriptionResponses,
  UploadReferenceDocumentData,
  UploadReferenceDocumentErrors,
  UploadReferenceDocumentResponses,
  UploadResumeForApplicationData,
  UploadResumeForApplicationErrors,
  UploadResumeForApplicationResponses,
  UpsertApplicationData,
  UpsertApplicationErrors,
  UpsertApplicationResponses,
  UpsertBookingConfigData,
  UpsertBookingConfigErrors,
  UpsertBookingConfigResponses,
  V2HealthHealthGetData,
  V2HealthHealthGetResponses,
  WorkflowAssignReviewerData,
  WorkflowAssignReviewerErrors,
  WorkflowAssignReviewerResponses,
  WorkflowBulkAssignByAddedByData,
  WorkflowBulkAssignByAddedByErrors,
  WorkflowBulkAssignByAddedByResponses,
  WorkflowBulkAssignReviewerData,
  WorkflowBulkAssignReviewerErrors,
  WorkflowBulkAssignReviewerResponses,
  WorkflowBulkChangeAssessmentDeadlineData,
  WorkflowBulkChangeAssessmentDeadlineErrors,
  WorkflowBulkChangeAssessmentDeadlineResponses,
  WorkflowBulkChangeDeadlineData,
  WorkflowBulkChangeDeadlineErrors,
  WorkflowBulkChangeDeadlineResponses,
  WorkflowBulkRejectBelowData,
  WorkflowBulkRejectBelowErrors,
  WorkflowBulkRejectBelowResponses,
  WorkflowBulkSendReminderData,
  WorkflowBulkSendReminderErrors,
  WorkflowBulkSendReminderResponses,
  WorkflowBulkTransitionData,
  WorkflowBulkTransitionErrors,
  WorkflowBulkTransitionResponses,
  WorkflowRejectBelowPreviewData,
  WorkflowRejectBelowPreviewErrors,
  WorkflowRejectBelowPreviewResponses,
  WorkflowReminderPreviewData,
  WorkflowReminderPreviewErrors,
  WorkflowReminderPreviewResponses,
  WorkflowSubmitHumanReviewData,
  WorkflowSubmitHumanReviewErrors,
  WorkflowSubmitHumanReviewResponses,
  WorkflowTransitionData,
  WorkflowTransitionErrors,
  WorkflowTransitionResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options_3<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get current tenant (public)
 *
 * Returns non-sensitive tenant identity — safe to call before the user has signed in. For full detail including settings, see `get_current_tenant`.
 */
export const getCurrentTenantPublic = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentTenantPublicData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetCurrentTenantPublicResponses,
    GetCurrentTenantPublicErrors,
    ThrowOnError
  >({ url: '/tenants/current/public', ...options });

/**
 * Get the current tenant
 *
 * Returns full tenant detail including configuration and settings.
 */
export const getCurrentTenant = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentTenantData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetCurrentTenantResponses,
    GetCurrentTenantErrors,
    ThrowOnError
  >({ url: '/tenants/current', ...options });

/**
 * Update the current tenant
 *
 * Updates the caller's own tenant profile and self-service settings. Platform-managed fields are not exposed and cannot be changed through this endpoint.
 */
export const updateCurrentTenant = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCurrentTenantData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateCurrentTenantResponses,
    UpdateCurrentTenantErrors,
    ThrowOnError
  >({
    url: '/tenants/current',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get caller's permissions for the current tenant
 *
 * Returns the authenticated user's tenant-level permissions, per-job permissions, and superuser flag. Account admins (manage_tenant_jobs) receive an empty job_permissions list — the frontend derives full job access from that permission.
 */
export const getMyPermissions = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyPermissionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetMyPermissionsResponses,
    GetMyPermissionsErrors,
    ThrowOnError
  >({ url: '/tenants/current/my-permissions', ...options });

/**
 * Hear text in the tenant's interviewer voice
 *
 * Synthesizes short text (a company name) with the voice the tenant's AI interviewer speaks with and returns it as MP3. 400 when the text is blank or longer than 200 characters; 502 when speech synthesis fails.
 */
export const pronounceWithTenantVoice = <ThrowOnError extends boolean = false>(
  options: Options<PronounceWithTenantVoiceData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    PronounceWithTenantVoiceResponses,
    PronounceWithTenantVoiceErrors,
    ThrowOnError
  >({ url: '/tenants/current/pronunciation', ...options });

/**
 * List all tenants
 *
 * Returns all tenants, oldest first. Admin only.
 */
export const listTenants = <ThrowOnError extends boolean = false>(
  options?: Options<ListTenantsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListTenantsResponses,
    ListTenantsErrors,
    ThrowOnError
  >({ url: '/tenants', ...options });

/**
 * Create a new tenant
 *
 * Creates a tenant and makes the caller its first admin. Fails if the domain is already taken. Admin only.
 */
export const createTenant = <ThrowOnError extends boolean = false>(
  options: Options<CreateTenantData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateTenantResponses,
    CreateTenantErrors,
    ThrowOnError
  >({
    url: '/tenants',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a tenant by id
 *
 * Admin only.
 */
export const getTenantById = <ThrowOnError extends boolean = false>(
  options: Options<GetTenantByIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetTenantByIdResponses,
    GetTenantByIdErrors,
    ThrowOnError
  >({ url: '/tenants/get', ...options });

/**
 * List Tenant Members
 */
export const listTenantMembers = <ThrowOnError extends boolean = false>(
  options?: Options<ListTenantMembersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListTenantMembersResponses,
    ListTenantMembersErrors,
    ThrowOnError
  >({ url: '/tenant-members', ...options });

/**
 * Invite Tenant Member
 */
export const inviteTenantMember = <ThrowOnError extends boolean = false>(
  options: Options<InviteTenantMemberData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InviteTenantMemberResponses,
    InviteTenantMemberErrors,
    ThrowOnError
  >({
    url: '/tenant-members/invite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Tenant Member Role
 */
export const updateTenantMemberRole = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTenantMemberRoleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateTenantMemberRoleResponses,
    UpdateTenantMemberRoleErrors,
    ThrowOnError
  >({
    url: '/tenant-members/update-role',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Tenant Member
 */
export const removeTenantMember = <ThrowOnError extends boolean = false>(
  options: Options<RemoveTenantMemberData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RemoveTenantMemberResponses,
    RemoveTenantMemberErrors,
    ThrowOnError
  >({
    url: '/tenant-members/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Tenant Roles
 */
export const listTenantRoles = <ThrowOnError extends boolean = false>(
  options?: Options<ListTenantRolesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListTenantRolesResponses,
    ListTenantRolesErrors,
    ThrowOnError
  >({ url: '/tenant-roles', ...options });

/**
 * Get an application by id
 */
export const getApplication = <ThrowOnError extends boolean = false>(
  options: Options<GetApplicationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetApplicationResponses,
    GetApplicationErrors,
    ThrowOnError
  >({ url: '/applications/get', ...options });

/**
 * List applications for a job
 */
export const listApplications = <ThrowOnError extends boolean = false>(
  options: Options<ListApplicationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListApplicationsResponses,
    ListApplicationsErrors,
    ThrowOnError
  >({ url: '/applications', ...options });

/**
 * Paginated row list for the Applications-v2 page
 */
export const listInterviewingApplications = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListInterviewingApplicationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListInterviewingApplicationsResponses,
    ListInterviewingApplicationsErrors,
    ThrowOnError
  >({ url: '/applications/list-interviewing', ...options });

/**
 * Cross-job candidate search (per-job RBAC scoped)
 */
export const globalCandidateSearch = <ThrowOnError extends boolean = false>(
  options?: Options<GlobalCandidateSearchData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GlobalCandidateSearchResponses,
    GlobalCandidateSearchErrors,
    ThrowOnError
  >({ url: '/applications/search-candidates', ...options });

/**
 * Aggregate bucket + board counts for the Applications-v2 page
 */
export const getInterviewingCounts = <ThrowOnError extends boolean = false>(
  options: Options<GetInterviewingCountsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetInterviewingCountsResponses,
    GetInterviewingCountsErrors,
    ThrowOnError
  >({ url: '/applications/get-interviewing-counts', ...options });

/**
 * Selectable values (batches) for the Applications-v2 listing filters
 */
export const getListingFilterOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetListingFilterOptionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetListingFilterOptionsResponses,
    GetListingFilterOptionsErrors,
    ThrowOnError
  >({ url: '/applications/get-listing-filters', ...options });

/**
 * One page of one All Candidates column
 */
export const listBoard = <ThrowOnError extends boolean = false>(
  options: Options<ListBoardData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListBoardResponses,
    ListBoardErrors,
    ThrowOnError
  >({ url: '/applications/board', ...options });

/**
 * Every All Candidates stage's count, and who added candidates to the job
 */
export const getBoardSummary = <ThrowOnError extends boolean = false>(
  options: Options<GetBoardSummaryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBoardSummaryResponses,
    GetBoardSummaryErrors,
    ThrowOnError
  >({ url: '/applications/board-summary', ...options });

/**
 * One candidate as the All Candidates board shows them
 */
export const getBoardRow = <ThrowOnError extends boolean = false>(
  options: Options<GetBoardRowData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBoardRowResponses,
    GetBoardRowErrors,
    ThrowOnError
  >({ url: '/applications/board-row', ...options });

/**
 * What the All Candidates Export offers, counted per tab
 */
export const getBoardExportOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetBoardExportOptionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBoardExportOptionsResponses,
    GetBoardExportOptionsErrors,
    ThrowOnError
  >({ url: '/applications/board-export-options', ...options });

/**
 * Download the All Candidates board as an .xlsx
 */
export const exportBoard = <ThrowOnError extends boolean = false>(
  options: Options<ExportBoardData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExportBoardResponses,
    ExportBoardErrors,
    ThrowOnError
  >({ url: '/applications/board-export', ...options });

/**
 * Most-recent active email template for a (job, trigger_event) pair
 */
export const getActiveEmailTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetActiveEmailTemplateData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetActiveEmailTemplateResponses,
    GetActiveEmailTemplateErrors,
    ThrowOnError
  >({ url: '/applications/get-active-email-template', ...options });

/**
 * Get Greenhouse ATS metadata for an application
 */
export const getGreenhouseMetadata = <ThrowOnError extends boolean = false>(
  options: Options<GetGreenhouseMetadataData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetGreenhouseMetadataResponses,
    GetGreenhouseMetadataErrors,
    ThrowOnError
  >({ url: '/applications/greenhouse', ...options });

/**
 * Record Greenhouse ATS callback metadata on an application
 */
export const recordGreenhouseMetadata = <ThrowOnError extends boolean = false>(
  options: Options<RecordGreenhouseMetadataData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RecordGreenhouseMetadataResponses,
    RecordGreenhouseMetadataErrors,
    ThrowOnError
  >({
    url: '/applications/greenhouse',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Export applications as XLSX, CSV, or JSON
 */
export const exportApplications = <ThrowOnError extends boolean = false>(
  options: Options<ExportApplicationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExportApplicationsResponses,
    ExportApplicationsErrors,
    ThrowOnError
  >({ url: '/applications/export', ...options });

/**
 * Get export modal option counts
 */
export const getExportOptions = <ThrowOnError extends boolean = false>(
  options: Options<GetExportOptionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetExportOptionsResponses,
    GetExportOptionsErrors,
    ThrowOnError
  >({ url: '/applications/export-options', ...options });

/**
 * Create or retrieve an application for a (job, user) pair
 */
export const upsertApplication = <ThrowOnError extends boolean = false>(
  options: Options<UpsertApplicationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpsertApplicationResponses,
    UpsertApplicationErrors,
    ThrowOnError
  >({
    url: '/applications/upsert',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set intake (pre-interview) metadata on an application
 */
export const setIntakeMetadata = <ThrowOnError extends boolean = false>(
  options: Options<SetIntakeMetadataData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SetIntakeMetadataResponses,
    SetIntakeMetadataErrors,
    ThrowOnError
  >({
    url: '/applications/intake-metadata',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Set the AI selection status on an application
 */
export const setSelectionStatus = <ThrowOnError extends boolean = false>(
  options: Options<SetSelectionStatusData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SetSelectionStatusResponses,
    SetSelectionStatusErrors,
    ThrowOnError
  >({
    url: '/applications/selection-status',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List jobs
 */
export const listJobs = <ThrowOnError extends boolean = false>(
  options?: Options<ListJobsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListJobsResponses,
    ListJobsErrors,
    ThrowOnError
  >({ url: '/jobs', ...options });

/**
 * Update a job
 */
export const updateJob = <ThrowOnError extends boolean = false>(
  options: Options<UpdateJobData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateJobResponses,
    UpdateJobErrors,
    ThrowOnError
  >({
    url: '/jobs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create a new job
 */
export const createJob = <ThrowOnError extends boolean = false>(
  options: Options<CreateJobData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateJobResponses,
    CreateJobErrors,
    ThrowOnError
  >({
    url: '/jobs',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get a job by id
 */
export const getJob = <ThrowOnError extends boolean = false>(
  options: Options<GetJobData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetJobResponses, GetJobErrors, ThrowOnError>({
    url: '/jobs/get',
    ...options,
  });

/**
 * List documents attached to a job
 */
export const listDocuments = <ThrowOnError extends boolean = false>(
  options: Options<ListDocumentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListDocumentsResponses,
    ListDocumentsErrors,
    ThrowOnError
  >({ url: '/jobs/documents', ...options });

/**
 * Get a signed download URL for a document
 */
export const getDocumentDownloadUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentDownloadUrlData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetDocumentDownloadUrlResponses,
    GetDocumentDownloadUrlErrors,
    ThrowOnError
  >({ url: '/jobs/documents/download', ...options });

/**
 * Get the text content of a document
 */
export const getDocumentContent = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentContentData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetDocumentContentResponses,
    GetDocumentContentErrors,
    ThrowOnError
  >({ url: '/jobs/documents/content', ...options });

/**
 * Save the stage choice and notes of a job in setup
 */
export const updateJobSetupState = <ThrowOnError extends boolean = false>(
  options: Options<UpdateJobSetupStateData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateJobSetupStateResponses,
    UpdateJobSetupStateErrors,
    ThrowOnError
  >({
    url: '/jobs/setup-state',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start generating the plans of chosen setup stages in the background
 */
export const startJobSetupGeneration = <ThrowOnError extends boolean = false>(
  options: Options<StartJobSetupGenerationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartJobSetupGenerationResponses,
    StartJobSetupGenerationErrors,
    ThrowOnError
  >({
    url: '/jobs/setup/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start generating the design of a stage a set-up job runs but has none for
 */
export const startJobDesignGeneration = <ThrowOnError extends boolean = false>(
  options: Options<StartJobDesignGenerationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartJobDesignGenerationResponses,
    StartJobDesignGenerationErrors,
    ThrowOnError
  >({
    url: '/jobs/design/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Archive (soft-delete) a job
 */
export const archiveJob = <ThrowOnError extends boolean = false>(
  options: Options<ArchiveJobData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    ArchiveJobResponses,
    ArchiveJobErrors,
    ThrowOnError
  >({
    url: '/jobs/archive',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Publish a job
 */
export const publishJob = <ThrowOnError extends boolean = false>(
  options: Options<PublishJobData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PublishJobResponses,
    PublishJobErrors,
    ThrowOnError
  >({
    url: '/jobs/publish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Unpublish a job
 */
export const unpublishJob = <ThrowOnError extends boolean = false>(
  options: Options<UnpublishJobData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    UnpublishJobResponses,
    UnpublishJobErrors,
    ThrowOnError
  >({
    url: '/jobs/unpublish',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload a reference document to a job
 */
export const uploadReferenceDocument = <ThrowOnError extends boolean = false>(
  options: Options<UploadReferenceDocumentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadReferenceDocumentResponses,
    UploadReferenceDocumentErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/jobs/documents/upload-reference',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Upload a job description document — stores to GCS and extracts text
 */
export const uploadJobDescription = <ThrowOnError extends boolean = false>(
  options: Options<UploadJobDescriptionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadJobDescriptionResponses,
    UploadJobDescriptionErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/jobs/documents/upload-job-description',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete a document from a job
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDocumentData, ThrowOnError>,
) =>
  (options.client ?? client).delete<
    DeleteDocumentResponses,
    DeleteDocumentErrors,
    ThrowOnError
  >({
    url: '/jobs/documents/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update live proctoring settings for a job
 */
export const updateLiveProctoring = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLiveProctoringData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateLiveProctoringResponses,
    UpdateLiveProctoringErrors,
    ThrowOnError
  >({
    url: '/jobs/update-live-proctoring',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update offline proctoring settings for a job
 */
export const updateOfflineProctoring = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOfflineProctoringData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateOfflineProctoringResponses,
    UpdateOfflineProctoringErrors,
    ThrowOnError
  >({
    url: '/jobs/update-offline-proctoring',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Replace the custom candidate instructions for a job (auto-instructions preserved)
 */
export const updateCustomInstructions = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCustomInstructionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateCustomInstructionsResponses,
    UpdateCustomInstructionsErrors,
    ThrowOnError
  >({
    url: '/jobs/update-custom-instructions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Booking Config
 */
export const getBookingConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetBookingConfigData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBookingConfigResponses,
    GetBookingConfigErrors,
    ThrowOnError
  >({ url: '/calendar-booking/config', ...options });

/**
 * Upsert Booking Config
 */
export const upsertBookingConfig = <ThrowOnError extends boolean = false>(
  options: Options<UpsertBookingConfigData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    UpsertBookingConfigResponses,
    UpsertBookingConfigErrors,
    ThrowOnError
  >({
    url: '/calendar-booking/config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Booking Slots
 */
export const getBookingSlots = <ThrowOnError extends boolean = false>(
  options: Options<GetBookingSlotsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBookingSlotsResponses,
    GetBookingSlotsErrors,
    ThrowOnError
  >({ url: '/calendar-booking/slots', ...options });

/**
 * Get Booking Status
 *
 * Booking status as a list. Pass ``job_id`` for a whole job's pipeline, or ``interview_id``
 * for one interview (returned as a single-item list). Exactly one of the two is required.
 *
 * ``interview_ids`` scopes a job read to the page the caller renders, and is required with
 * ``job_id``: unscoped, the response carries a row per candidate on the job, which is thousands on
 * the largest ones, and the pipeline re-reads on every window focus. It applies only to a
 * ``job_id`` read, and is rejected rather than ignored alongside ``interview_id``.
 */
export const getBookingStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetBookingStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetBookingStatusResponses,
    GetBookingStatusErrors,
    ThrowOnError
  >({ url: '/calendar-booking/status', ...options });

/**
 * List Pending Booking Invites
 *
 * Candidates invited before Calendar Booking was enabled who still hold no booking link.
 */
export const listPendingBookingInvites = <ThrowOnError extends boolean = false>(
  options: Options<ListPendingBookingInvitesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListPendingBookingInvitesResponses,
    ListPendingBookingInvitesErrors,
    ThrowOnError
  >({ url: '/calendar-booking/pending-invites', ...options });

/**
 * Get Booking Ics
 */
export const getBookingIcs = <ThrowOnError extends boolean = false>(
  options: Options<GetBookingIcsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBookingIcsResponses,
    GetBookingIcsErrors,
    ThrowOnError
  >({ url: '/calendar-booking/ics', ...options });

/**
 * Book Slot
 */
export const bookSlot = <ThrowOnError extends boolean = false>(
  options: Options<BookSlotData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BookSlotResponses,
    BookSlotErrors,
    ThrowOnError
  >({
    url: '/calendar-booking/book',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Request Reschedule
 */
export const requestReschedule = <ThrowOnError extends boolean = false>(
  options: Options<RequestRescheduleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RequestRescheduleResponses,
    RequestRescheduleErrors,
    ThrowOnError
  >({
    url: '/calendar-booking/reschedule-request',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Review Reschedule
 */
export const reviewReschedule = <ThrowOnError extends boolean = false>(
  options: Options<ReviewRescheduleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ReviewRescheduleResponses,
    ReviewRescheduleErrors,
    ThrowOnError
  >({
    url: '/calendar-booking/reschedule-review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Restore Declined
 */
export const restoreDeclined = <ThrowOnError extends boolean = false>(
  options: Options<RestoreDeclinedData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RestoreDeclinedResponses,
    RestoreDeclinedErrors,
    ThrowOnError
  >({
    url: '/calendar-booking/reschedule-request/restore',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Send Booking Invites
 *
 * Send the booking invite to candidates who were invited before booking was enabled.
 */
export const sendBookingInvites = <ThrowOnError extends boolean = false>(
  options: Options<SendBookingInvitesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SendBookingInvitesResponses,
    SendBookingInvitesErrors,
    ThrowOnError
  >({
    url: '/calendar-booking/send-booking-invites',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Booking Unsubscribe
 */
export const bookingUnsubscribe = <ThrowOnError extends boolean = false>(
  options: Options<BookingUnsubscribeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BookingUnsubscribeResponses,
    BookingUnsubscribeErrors,
    ThrowOnError
  >({ url: '/calendar-booking/unsubscribe/{interview_id}', ...options });

/**
 * Booking Withdraw
 */
export const bookingWithdraw = <ThrowOnError extends boolean = false>(
  options: Options<BookingWithdrawData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BookingWithdrawResponses,
    BookingWithdrawErrors,
    ThrowOnError
  >({ url: '/calendar-booking/withdraw/{interview_id}', ...options });

/**
 * List Copilot Rounds
 *
 * Who is in this job's round. The recruiter's view, scoped by job.
 */
export const listCopilotRounds = <ThrowOnError extends boolean = false>(
  options: Options<ListCopilotRoundsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListCopilotRoundsResponses,
    ListCopilotRoundsErrors,
    ThrowOnError
  >({ url: '/copilot/rounds', ...options });

/**
 * List My Copilot Rounds
 *
 * The rounds assigned to the caller. Takes no job_id on purpose.
 *
 * An interviewer has no job-wide candidate permission, so there is no job for
 * them to ask about; the rounds naming them are the whole of what they see.
 */
export const listMyCopilotRounds = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyCopilotRoundsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListMyCopilotRoundsResponses,
    ListMyCopilotRoundsErrors,
    ThrowOnError
  >({ url: '/copilot/my-rounds', ...options });

/**
 * Get My Copilot Round
 */
export const getMyCopilotRound = <ThrowOnError extends boolean = false>(
  options: Options<GetMyCopilotRoundData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetMyCopilotRoundResponses,
    GetMyCopilotRoundErrors,
    ThrowOnError
  >({ url: '/copilot/my-rounds/{copilot_interview_id}', ...options });

/**
 * Get Copilot Round
 *
 * This job's round and its guide, or null when it has none.
 *
 * Singular, and separate from `/copilot/rounds`, which lists the candidates in
 * the round rather than the round itself.
 */
export const getCopilotRound = <ThrowOnError extends boolean = false>(
  options: Options<GetCopilotRoundData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCopilotRoundResponses,
    GetCopilotRoundErrors,
    ThrowOnError
  >({ url: '/copilot/round', ...options });

/**
 * Get Application Copilot Round
 *
 * The candidate's copilot round and its submitted feedback, for the hiring
 * team. Null when the candidate has no copilot round.
 */
export const getApplicationCopilotRound = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApplicationCopilotRoundData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetApplicationCopilotRoundResponses,
    GetApplicationCopilotRoundErrors,
    ThrowOnError
  >({ url: '/copilot/applications/{application_id}/round', ...options });

/**
 * Get Copilot Transcript
 *
 * What has been heard so far. Polled by the round page while a call runs.
 */
export const getCopilotTranscript = <ThrowOnError extends boolean = false>(
  options: Options<GetCopilotTranscriptData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCopilotTranscriptResponses,
    GetCopilotTranscriptErrors,
    ThrowOnError
  >({
    url: '/copilot/my-rounds/{copilot_interview_id}/transcript',
    ...options,
  });

/**
 * Get Copilot Feedback
 *
 * The interviewer's own feedback, or a blank form on the guide's areas. Never R41's.
 */
export const getCopilotFeedback = <ThrowOnError extends boolean = false>(
  options: Options<GetCopilotFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCopilotFeedbackResponses,
    GetCopilotFeedbackErrors,
    ThrowOnError
  >({ url: '/copilot/my-rounds/{copilot_interview_id}/feedback', ...options });

/**
 * Schedule Copilot Round
 */
export const scheduleCopilotRound = <ThrowOnError extends boolean = false>(
  options: Options<ScheduleCopilotRoundData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ScheduleCopilotRoundResponses,
    ScheduleCopilotRoundErrors,
    ThrowOnError
  >({
    url: '/copilot/schedule',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Send Copilot Round Invites
 *
 * Sending is per recipient, so this answers 200 with a per-recipient result.
 *
 * A candidate's address failing must not hide that the interviewer's landed.
 */
export const sendCopilotRoundInvites = <ThrowOnError extends boolean = false>(
  options: Options<SendCopilotRoundInvitesData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SendCopilotRoundInvitesResponses,
    SendCopilotRoundInvitesErrors,
    ThrowOnError
  >({
    url: '/copilot/send-invites',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Mark Copilot Round No Show
 *
 * Record that a scheduled call did not happen. Leaves the candidate's stage alone.
 */
export const markCopilotRoundNoShow = <ThrowOnError extends boolean = false>(
  options: Options<MarkCopilotRoundNoShowData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MarkCopilotRoundNoShowResponses,
    MarkCopilotRoundNoShowErrors,
    ThrowOnError
  >({
    url: '/copilot/mark-no-show',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reschedule Copilot Round
 *
 * Book a no-show round again at a new time. Send the invites after, through `/send-invites`.
 */
export const rescheduleCopilotRound = <ThrowOnError extends boolean = false>(
  options: Options<RescheduleCopilotRoundData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RescheduleCopilotRoundResponses,
    RescheduleCopilotRoundErrors,
    ThrowOnError
  >({
    url: '/copilot/reschedule',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Start Copilot Listening
 *
 * Hand the browser somewhere to publish the call's audio.
 *
 * A mutation, not a read: it moves the round to in progress, and the address
 * it returns expires, so nothing about it is safe to repeat or cache.
 */
export const startCopilotListening = <ThrowOnError extends boolean = false>(
  options: Options<StartCopilotListeningData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartCopilotListeningResponses,
    StartCopilotListeningErrors,
    ThrowOnError
  >({
    url: '/copilot/listen',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Stop Copilot Listening
 *
 * Close the round and answer with the record it ends on.
 *
 * Returns the transcript rather than an acknowledgement so the page can render
 * the finished round from this one response, without a poll that might arrive
 * before the write it is waiting for.
 */
export const stopCopilotListening = <ThrowOnError extends boolean = false>(
  options: Options<StopCopilotListeningData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StopCopilotListeningResponses,
    StopCopilotListeningErrors,
    ThrowOnError
  >({
    url: '/copilot/stop',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Copilot Round
 *
 * Generate the guide, which is what creates the round.
 *
 * Runs a model call, so it is slow by the standards of everything else here:
 * about a minute. Verb-shaped rather than a POST to `/copilot/rounds`, which
 * already means the candidates in the round.
 */
export const createCopilotRound = <ThrowOnError extends boolean = false>(
  options: Options<CreateCopilotRoundData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateCopilotRoundResponses,
    CreateCopilotRoundErrors,
    ThrowOnError
  >({
    url: '/copilot/create-round',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Copilot Guide
 *
 * Save the recruiter's own wording over the model's.
 *
 * Answers with the whole round, not an acknowledgement, so the page renders
 * what was stored rather than what it hoped was stored.
 */
export const updateCopilotGuide = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCopilotGuideData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateCopilotGuideResponses,
    UpdateCopilotGuideErrors,
    ThrowOnError
  >({
    url: '/copilot/update-guide',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Refine Copilot Guide
 *
 * Write the guide again with one instruction applied.
 *
 * As slow as creating the round, and for the same reason: it is the same model
 * call with the current guide in front of it.
 */
export const refineCopilotGuide = <ThrowOnError extends boolean = false>(
  options: Options<RefineCopilotGuideData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RefineCopilotGuideResponses,
    RefineCopilotGuideErrors,
    ThrowOnError
  >({
    url: '/copilot/refine-guide',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete Copilot Guide Item
 *
 * Write the area and the nudges around a question the recruiter typed.
 *
 * Stores nothing: the answer fills the row in their editor, and is written
 * when they save the guide. A POST rather than a GET because it costs a model
 * call, and a GET that spends money is a GET somebody will cache.
 */
export const completeCopilotGuideItem = <ThrowOnError extends boolean = false>(
  options: Options<CompleteCopilotGuideItemData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CompleteCopilotGuideItemResponses,
    CompleteCopilotGuideItemErrors,
    ThrowOnError
  >({
    url: '/copilot/complete-guide-item',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Regenerate Copilot Guide
 *
 * Write the plan again from the posting and the round's context.
 *
 * Replaces every row, including questions the recruiter wrote, so the screen
 * asks before calling it.
 */
export const regenerateCopilotGuide = <ThrowOnError extends boolean = false>(
  options: Options<RegenerateCopilotGuideData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RegenerateCopilotGuideResponses,
    RegenerateCopilotGuideErrors,
    ThrowOnError
  >({
    url: '/copilot/regenerate-guide',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Suggest Copilot Questions
 *
 * A few questions for the area the call is in, for the interviewer to read out.
 *
 * A POST rather than a GET because it costs a model call.
 */
export const suggestCopilotQuestions = <ThrowOnError extends boolean = false>(
  options: Options<SuggestCopilotQuestionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SuggestCopilotQuestionsResponses,
    SuggestCopilotQuestionsErrors,
    ThrowOnError
  >({
    url: '/copilot/suggest-questions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Save Copilot Feedback
 *
 * Save the interviewer's edits, and submit them when asked. The areas stay as drafted.
 */
export const saveCopilotFeedback = <ThrowOnError extends boolean = false>(
  options: Options<SaveCopilotFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SaveCopilotFeedbackResponses,
    SaveCopilotFeedbackErrors,
    ThrowOnError
  >({
    url: '/copilot/save-feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Suggest Copilot Start
 *
 * Work out, once, which area this candidate's round should open with. Returns the round.
 */
export const suggestCopilotStart = <ThrowOnError extends boolean = false>(
  options: Options<SuggestCopilotStartData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SuggestCopilotStartResponses,
    SuggestCopilotStartErrors,
    ThrowOnError
  >({
    url: '/copilot/suggest-start',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Team Members
 */
export const listTeamMembers = <ThrowOnError extends boolean = false>(
  options: Options<ListTeamMembersData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListTeamMembersResponses,
    ListTeamMembersErrors,
    ThrowOnError
  >({ url: '/team-members', ...options });

/**
 * Add Team Member
 */
export const addTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<AddTeamMemberData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AddTeamMemberResponses,
    AddTeamMemberErrors,
    ThrowOnError
  >({
    url: '/team-members/add',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Team Member Role
 */
export const updateTeamMemberRole = <ThrowOnError extends boolean = false>(
  options: Options<UpdateTeamMemberRoleData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateTeamMemberRoleResponses,
    UpdateTeamMemberRoleErrors,
    ThrowOnError
  >({
    url: '/team-members/update-role',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Team Member
 */
export const removeTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<RemoveTeamMemberData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RemoveTeamMemberResponses,
    RemoveTeamMemberErrors,
    ThrowOnError
  >({
    url: '/team-members/remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get per-section duration limits
 *
 * Returns the duration floor, ceiling, default, and control mode for each section type. The frontend fetches this once per session to render the correct duration widget.
 */
export const getSectionTimeLimits = <ThrowOnError extends boolean = false>(
  options?: Options<GetSectionTimeLimitsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSectionTimeLimitsResponses,
    GetSectionTimeLimitsErrors,
    ThrowOnError
  >({ url: '/interview-plans/section-time-limits', ...options });

/**
 * List interview plans for a job
 */
export const listInterviewPlans = <ThrowOnError extends boolean = false>(
  options: Options<ListInterviewPlansData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListInterviewPlansResponses,
    ListInterviewPlansErrors,
    ThrowOnError
  >({ url: '/interview-plans', ...options });

/**
 * Get an interview plan
 */
export const getInterviewPlan = <ThrowOnError extends boolean = false>(
  options: Options<GetInterviewPlanData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetInterviewPlanResponses,
    GetInterviewPlanErrors,
    ThrowOnError
  >({ url: '/interview-plans/get', ...options });

/**
 * Get cached section library for a job
 */
export const getCachedSections = <ThrowOnError extends boolean = false>(
  options: Options<GetCachedSectionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCachedSectionsResponses,
    GetCachedSectionsErrors,
    ThrowOnError
  >({ url: '/cached-sections', ...options });

/**
 * Get the evaluation rubric for an interview plan
 *
 * Returns the stored rubric. Returns 404 if no rubric has been generated yet — call POST /interview-plans/rubric/generate to create one.
 */
export const getInterviewPlanRubric = <ThrowOnError extends boolean = false>(
  options: Options<GetInterviewPlanRubricData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetInterviewPlanRubricResponses,
    GetInterviewPlanRubricErrors,
    ThrowOnError
  >({ url: '/interview-plans/rubric', ...options });

/**
 * Get the planner wizard draft state for a job
 *
 * Returns wizard fields persisted on the Job row plus derived `current_step` and `is_locked`. Always returns 200 — empty/default values if the user hasn't started the wizard yet. `is_locked=true` once a plan exists for the job (draft becomes read-only).
 */
export const getInterviewPlanDraft = <ThrowOnError extends boolean = false>(
  options: Options<GetInterviewPlanDraftData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetInterviewPlanDraftResponses,
    GetInterviewPlanDraftErrors,
    ThrowOnError
  >({ url: '/interview-plans/draft', ...options });

/**
 * Apply an operation to an interview plan
 *
 * Operation-based plan mutation. Supported operations: edit, add-section, remove-section, reorder-sections, regenerate, dismiss-stale, dismiss-all-stale. Returns the updated plan with plan_meta (duration budget, section limits). Returns 409 on version conflict, 404 if section not found.
 */
export const applyPlanOperation = <ThrowOnError extends boolean = false>(
  options: Options<ApplyPlanOperationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApplyPlanOperationResponses,
    ApplyPlanOperationErrors,
    ThrowOnError
  >({
    url: '/interview-plans/apply',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create an AI-generated interview plan
 *
 * Generates a complete interview plan using AI. May take up to 2 minutes.
 */
export const createInterviewPlan = <ThrowOnError extends boolean = false>(
  options: Options<CreateInterviewPlanData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateInterviewPlanResponses,
    CreateInterviewPlanErrors,
    ThrowOnError
  >({
    url: '/interview-plans/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate (or return existing) evaluation rubric for an interview plan
 *
 * Returns the existing rubric if present unless ``force_regenerate=true``. Otherwise calls the LLM to generate a new rubric, persists it to plan.params, and returns it. Generation can take 10–60s.
 */
export const generateInterviewPlanRubric = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateInterviewPlanRubricData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateInterviewPlanRubricResponses,
    GenerateInterviewPlanRubricErrors,
    ThrowOnError
  >({
    url: '/interview-plans/rubric/generate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Manually replace the evaluation rubric for an interview plan
 *
 * Replaces the rubric on a plan with a hand-edited version. Criterion weights must sum to 1.0 (±0.01) — 422 otherwise.
 */
export const updateInterviewPlanRubric = <ThrowOnError extends boolean = false>(
  options: Options<UpdateInterviewPlanRubricData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateInterviewPlanRubricResponses,
    UpdateInterviewPlanRubricErrors,
    ThrowOnError
  >({
    url: '/interview-plans/rubric/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Save the planner wizard draft state for a job
 *
 * Idempotent full-state replacement of wizard fields on the Job row. Returns 409 if a plan already exists for the job (the draft is locked). Side effect: if Job.description is empty, the saved jd_text is mirrored into it — jobs created entirely through the wizard never went through POST /jobs.
 */
export const saveInterviewPlanDraft = <ThrowOnError extends boolean = false>(
  options: Options<SaveInterviewPlanDraftData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SaveInterviewPlanDraftResponses,
    SaveInterviewPlanDraftErrors,
    ThrowOnError
  >({
    url: '/interview-plans/draft/save',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Pass-through LLM call for the Question Generator sales-demo tool
 */
export const questionGeneratorLlm = <ThrowOnError extends boolean = false>(
  options: Options<QuestionGeneratorLlmData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    QuestionGeneratorLlmResponses,
    QuestionGeneratorLlmErrors,
    ThrowOnError
  >({
    url: '/question-generator/llm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Read a planner session's status, gate payload, or result
 *
 * Read a session.
 */
export const getPlannerSession = <ThrowOnError extends boolean = false>(
  options: Options<GetPlannerSessionData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPlannerSessionResponses,
    GetPlannerSessionErrors,
    ThrowOnError
  >({ url: '/agentic-planner/sessions/{session_id}', ...options });

/**
 * Read a session's per-node turn log, including any failure's kind
 *
 * Read a session's turn log.
 */
export const getPlannerTurns = <ThrowOnError extends boolean = false>(
  options: Options<GetPlannerTurnsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPlannerTurnsResponses,
    GetPlannerTurnsErrors,
    ThrowOnError
  >({ url: '/agentic-planner/sessions/{session_id}/turns', ...options });

/**
 * Start a planner session for a job; drafting runs as a background job
 *
 * Start a session for a job.
 */
export const startPlannerSession = <ThrowOnError extends boolean = false>(
  options: Options<StartPlannerSessionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartPlannerSessionResponses,
    StartPlannerSessionErrors,
    ThrowOnError
  >({
    url: '/agentic-planner/sessions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Seed a planner session from the job's stored plan and start the migrate chain
 *
 * Start a session from the job's stored plan.
 */
export const migratePlannerSession = <ThrowOnError extends boolean = false>(
  options: Options<MigratePlannerSessionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MigratePlannerSessionResponses,
    MigratePlannerSessionErrors,
    ThrowOnError
  >({
    url: '/agentic-planner/sessions/migrate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Answer the review gate (approve, refine, wrong_focus, abort)
 *
 * Answer the review gate.
 */
export const decidePlannerSession = <ThrowOnError extends boolean = false>(
  options: Options<DecidePlannerSessionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    DecidePlannerSessionResponses,
    DecidePlannerSessionErrors,
    ThrowOnError
  >({
    url: '/agentic-planner/sessions/{session_id}/decide',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Apply structured high-level section edits; a changed section regenerates at the next compile
 *
 * Apply structured edits to the draft.
 */
export const editPlannerSession = <ThrowOnError extends boolean = false>(
  options: Options<EditPlannerSessionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    EditPlannerSessionResponses,
    EditPlannerSessionErrors,
    ThrowOnError
  >({
    url: '/agentic-planner/sessions/{session_id}/edit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Re-enqueue a planner session whose background job was lost (idempotent)
 *
 * Re-enqueue an idle session's background job.
 */
export const resumePlannerSession = <ThrowOnError extends boolean = false>(
  options: Options<ResumePlannerSessionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResumePlannerSessionResponses,
    ResumePlannerSessionErrors,
    ThrowOnError
  >({ url: '/agentic-planner/sessions/{session_id}/resume', ...options });

/**
 * Persist the finished session's plan as a new interview plan for the job
 *
 * Save the finished plan as the job's interview plan.
 */
export const applyPlannerSession = <ThrowOnError extends boolean = false>(
  options: Options<ApplyPlannerSessionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApplyPlannerSessionResponses,
    ApplyPlannerSessionErrors,
    ThrowOnError
  >({
    url: '/agentic-planner/sessions/{session_id}/apply',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Suggest interview topics for a section
 */
export const suggestTopics = <ThrowOnError extends boolean = false>(
  options: Options<SuggestTopicsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SuggestTopicsResponses,
    SuggestTopicsErrors,
    ThrowOnError
  >({
    url: '/interview-plans/suggestions/topics',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Suggest subtopics for a topic
 */
export const suggestSubtopics = <ThrowOnError extends boolean = false>(
  options: Options<SuggestSubtopicsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SuggestSubtopicsResponses,
    SuggestSubtopicsErrors,
    ThrowOnError
  >({
    url: '/interview-plans/suggestions/subtopics',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Suggest interview questions for a section
 */
export const suggestQuestions = <ThrowOnError extends boolean = false>(
  options: Options<SuggestQuestionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SuggestQuestionsResponses,
    SuggestQuestionsErrors,
    ThrowOnError
  >({
    url: '/interview-plans/suggestions/questions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Regenerate case study content for a section
 */
export const regenerateCaseStudy = <ThrowOnError extends boolean = false>(
  options: Options<RegenerateCaseStudyData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RegenerateCaseStudyResponses,
    RegenerateCaseStudyErrors,
    ThrowOnError
  >({
    url: '/interview-plans/suggestions/case-study',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate a sample interactive coding problem
 */
export const generateInteractiveProblem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateInteractiveProblemData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateInteractiveProblemResponses,
    GenerateInteractiveProblemErrors,
    ThrowOnError
  >({
    url: '/interview-plans/suggestions/interactive-problem',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Suggest values for interactive coding config fields
 */
export const suggestInteractiveConfig = <ThrowOnError extends boolean = false>(
  options: Options<SuggestInteractiveConfigData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SuggestInteractiveConfigResponses,
    SuggestInteractiveConfigErrors,
    ThrowOnError
  >({
    url: '/interview-plans/suggestions/interactive-config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate evaluation criteria for a section
 */
export const generateSectionCriteria = <ThrowOnError extends boolean = false>(
  options: Options<GenerateSectionCriteriaData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateSectionCriteriaResponses,
    GenerateSectionCriteriaErrors,
    ThrowOnError
  >({
    url: '/interview-plans/suggestions/section-criteria',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Expand a draft job description into a complete one
 */
export const expandJobDescription = <ThrowOnError extends boolean = false>(
  options: Options<ExpandJobDescriptionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ExpandJobDescriptionResponses,
    ExpandJobDescriptionErrors,
    ThrowOnError
  >({
    url: '/jd/expand',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Refine an existing job description based on user feedback
 */
export const refineJobDescription = <ThrowOnError extends boolean = false>(
  options: Options<RefineJobDescriptionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RefineJobDescriptionResponses,
    RefineJobDescriptionErrors,
    ThrowOnError
  >({
    url: '/jd/refine',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Refine a selected portion of a job description
 */
export const refineJdSelection = <ThrowOnError extends boolean = false>(
  options: Options<RefineJdSelectionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RefineJdSelectionResponses,
    RefineJdSelectionErrors,
    ThrowOnError
  >({
    url: '/jd/refine-selection',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List the canonical simulation personas
 */
export const listSimulationPersonas = <ThrowOnError extends boolean = false>(
  options?: Options<ListSimulationPersonasData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListSimulationPersonasResponses,
    unknown,
    ThrowOnError
  >({ url: '/simulations/personas', ...options });

/**
 * Read one canonical persona, including the character prompt it renders
 */
export const getSimulationPersona = <ThrowOnError extends boolean = false>(
  options: Options<GetSimulationPersonaData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSimulationPersonaResponses,
    GetSimulationPersonaErrors,
    ThrowOnError
  >({ url: '/simulations/personas/{slug}', ...options });

/**
 * Prepare a persona for a plan: the snapshot a run plays, its hashes, and the skill mapping
 *
 * The slow half of starting a run, and the step `POST /simulations` requires. Resolving a pairing for the first time is two model calls; this writes only caches, so an abandoned prepare creates no application, interview or run. Start with the `instance_hash` it returns.
 */
export const resolveSimulationPersona = <ThrowOnError extends boolean = false>(
  options: Options<ResolveSimulationPersonaData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ResolveSimulationPersonaResponses,
    ResolveSimulationPersonaErrors,
    ThrowOnError
  >({
    url: '/simulations/personas/resolve',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Check an interview against a persona's expectations
 */
export const checkSimulationAssertions = <ThrowOnError extends boolean = false>(
  options: Options<CheckSimulationAssertionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CheckSimulationAssertionsResponses,
    CheckSimulationAssertionsErrors,
    ThrowOnError
  >({
    url: '/simulations/assertions/check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Judge a finished run again on the evidence it already has
 *
 * The same check the completion hook runs, on a run that has already been judged, replacing its verdict. Nothing is re-derived: the persona, the skill mapping and the transcript are the ones the run played. Pass `apparatus` to re-pin the judges first, which is how a change to a judge is shown to be an improvement rather than a difference.
 */
export const recheckSimulation = <ThrowOnError extends boolean = false>(
  options: Options<RecheckSimulationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RecheckSimulationResponses,
    RecheckSimulationErrors,
    ThrowOnError
  >({
    url: '/simulations/recheck',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List the simulation runs on a job
 */
export const listSimulations = <ThrowOnError extends boolean = false>(
  options: Options<ListSimulationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListSimulationsResponses,
    ListSimulationsErrors,
    ThrowOnError
  >({ url: '/simulations', ...options });

/**
 * Run a prepared persona against a plan: creates the candidate, the interview, and dispatches the runner
 *
 * Requires a pairing already prepared by `POST /simulations/personas/resolve`, and the `instance_hash` that call returned. A pairing that has never been prepared is a 409 rather than a two-minute wait, and creates nothing.
 */
export const startSimulation = <ThrowOnError extends boolean = false>(
  options: Options<StartSimulationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartSimulationResponses,
    StartSimulationErrors,
    ThrowOnError
  >({
    url: '/simulations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * The conversation so far and how far through the run is
 *
 * Built for polling while a run is going: the transcript sections and the progress, and nothing else. Before the first events land it returns an empty transcript rather than a 404, which is the run starting rather than an error.
 */
export const getSimulationTranscript = <ThrowOnError extends boolean = false>(
  options: Options<GetSimulationTranscriptData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSimulationTranscriptResponses,
    GetSimulationTranscriptErrors,
    ThrowOnError
  >({ url: '/simulations/{simulation_id}/transcript', ...options });

/**
 * Status, progress through the interview, and assertion results once they exist
 */
export const getSimulation = <ThrowOnError extends boolean = false>(
  options: Options<GetSimulationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSimulationResponses,
    GetSimulationErrors,
    ThrowOnError
  >({ url: '/simulations/{simulation_id}', ...options });

/**
 * Draft an editable persona from an uploaded resume
 */
export const generateSimulationPersona = <ThrowOnError extends boolean = false>(
  options: Options<GenerateSimulationPersonaData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateSimulationPersonaResponses,
    GenerateSimulationPersonaErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/simulations/personas/generate',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get the active screener plan for a job
 */
export const getScreenerPlan = <ThrowOnError extends boolean = false>(
  options: Options<GetScreenerPlanData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetScreenerPlanResponses,
    GetScreenerPlanErrors,
    ThrowOnError
  >({ url: '/screener/plan/get', ...options });

/**
 * Export all screener plan versions and their scores
 */
export const exportScreenerPlans = <ThrowOnError extends boolean = false>(
  options: Options<ExportScreenerPlansData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ExportScreenerPlansResponses,
    ExportScreenerPlansErrors,
    ThrowOnError
  >({ url: '/screener/plan/export', ...options });

/**
 * Get Public Screener Application
 */
export const getPublicScreenerApplication = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPublicScreenerApplicationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPublicScreenerApplicationResponses,
    GetPublicScreenerApplicationErrors,
    ThrowOnError
  >({ url: '/screener/public', ...options });

/**
 * List applications + their screener results for a job
 */
export const getScreeningApplications = <ThrowOnError extends boolean = false>(
  options: Options<GetScreeningApplicationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetScreeningApplicationsResponses,
    GetScreeningApplicationsErrors,
    ThrowOnError
  >({ url: '/screener/applications', ...options });

/**
 * Get one screening application with all rubric results
 */
export const getScreeningApplication = <ThrowOnError extends boolean = false>(
  options: Options<GetScreeningApplicationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetScreeningApplicationResponses,
    GetScreeningApplicationErrors,
    ThrowOnError
  >({ url: '/screener/applications/get', ...options });

/**
 * The job's active application questions (with options), read-only for the design page
 */
export const getJobApplicationQuestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetJobApplicationQuestionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetJobApplicationQuestionsResponses,
    GetJobApplicationQuestionsErrors,
    ThrowOnError
  >({ url: '/screener/application-questions', ...options });

/**
 * Generate Screener Share Token
 */
export const generateScreenerShareToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateScreenerShareTokenData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateScreenerShareTokenResponses,
    GenerateScreenerShareTokenErrors,
    ThrowOnError
  >({
    url: '/screener/share-token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate a fresh screener plan for a job (LLM-driven)
 */
export const createScreenerPlan = <ThrowOnError extends boolean = false>(
  options: Options<CreateScreenerPlanData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateScreenerPlanResponses,
    CreateScreenerPlanErrors,
    ThrowOnError
  >({
    url: '/screener/plan/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * In-place update of an active screener plan. Wipes Screening rows for re-evaluation.
 */
export const updateScreenerPlan = <ThrowOnError extends boolean = false>(
  options: Options<UpdateScreenerPlanData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateScreenerPlanResponses,
    UpdateScreenerPlanErrors,
    ThrowOnError
  >({
    url: '/screener/plan/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Fan out evaluation tasks across every application on the job
 */
export const evaluateScreenerJob = <ThrowOnError extends boolean = false>(
  options: Options<EvaluateScreenerJobData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    EvaluateScreenerJobResponses,
    EvaluateScreenerJobErrors,
    ThrowOnError
  >({
    url: '/screener/evaluate-job',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Trigger evaluation for a single application
 */
export const evaluateScreenerApplication = <
  ThrowOnError extends boolean = false,
>(
  options: Options<EvaluateScreenerApplicationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    EvaluateScreenerApplicationResponses,
    EvaluateScreenerApplicationErrors,
    ThrowOnError
  >({
    url: '/screener/evaluate-application',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Add an application question to a job
 */
export const createApplicationQuestion = <ThrowOnError extends boolean = false>(
  options: Options<CreateApplicationQuestionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateApplicationQuestionResponses,
    CreateApplicationQuestionErrors,
    ThrowOnError
  >({
    url: '/application-questions/create',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Save changes to a job's application question
 */
export const updateApplicationQuestion = <ThrowOnError extends boolean = false>(
  options: Options<UpdateApplicationQuestionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateApplicationQuestionResponses,
    UpdateApplicationQuestionErrors,
    ThrowOnError
  >({
    url: '/application-questions/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete a job's application question, or hide it once candidates answered it
 */
export const deleteApplicationQuestion = <ThrowOnError extends boolean = false>(
  options: Options<DeleteApplicationQuestionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    DeleteApplicationQuestionResponses,
    DeleteApplicationQuestionErrors,
    ThrowOnError
  >({
    url: '/application-questions/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * The profile photo a candidate gave with an application, as a signed link
 */
export const getApplicationPhoto = <ThrowOnError extends boolean = false>(
  options: Options<GetApplicationPhotoData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetApplicationPhotoResponses,
    GetApplicationPhotoErrors,
    ThrowOnError
  >({ url: '/application-questions/photo', ...options });

/**
 * Read-only: the current photo version of each listed application that has a photo
 */
export const getApplicationPhotoVersions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetApplicationPhotoVersionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GetApplicationPhotoVersionsResponses,
    GetApplicationPhotoVersionsErrors,
    ThrowOnError
  >({
    url: '/application-questions/photo-versions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * The profile photo a candidate gave with an application, as a JPEG
 *
 * Cached for good when `v` is the current version (from photo-versions), revalidated otherwise. 404 when the application has no photo.
 */
export const getApplicationPhotoImage = <ThrowOnError extends boolean = false>(
  options: Options<GetApplicationPhotoImageData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetApplicationPhotoImageResponses,
    GetApplicationPhotoImageErrors,
    ThrowOnError
  >({ url: '/application-questions/photo/image', ...options });

/**
 * Get the candidate's prescreen conversation, or null when the job has none
 */
export const getPrescreenConversation = <ThrowOnError extends boolean = false>(
  options: Options<GetPrescreenConversationData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPrescreenConversationResponses,
    GetPrescreenConversationErrors,
    ThrowOnError
  >({ url: '/prescreen/conversation', ...options });

/**
 * Start Conversation
 */
export const startPrescreenConversation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<StartPrescreenConversationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartPrescreenConversationResponses,
    StartPrescreenConversationErrors,
    ThrowOnError
  >({
    url: '/prescreen/conversation/start',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Complete Conversation
 */
export const completePrescreenConversation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CompletePrescreenConversationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CompletePrescreenConversationResponses,
    CompletePrescreenConversationErrors,
    ThrowOnError
  >({
    url: '/prescreen/conversation/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get the full conversation with transcript (recruiter)
 */
export const getPrescreenConversationDetail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPrescreenConversationDetailData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPrescreenConversationDetailResponses,
    GetPrescreenConversationDetailErrors,
    ThrowOnError
  >({ url: '/prescreen/conversation/detail', ...options });

/**
 * Conversation status for every application on a job (recruiter)
 */
export const getPrescreenConversations = <ThrowOnError extends boolean = false>(
  options: Options<GetPrescreenConversationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPrescreenConversationsResponses,
    GetPrescreenConversationsErrors,
    ThrowOnError
  >({ url: '/prescreen/conversations', ...options });

/**
 * Stop waiting on the candidate and screen them now (recruiter)
 */
export const forceReleasePrescreenConversation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ForceReleasePrescreenConversationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ForceReleasePrescreenConversationResponses,
    ForceReleasePrescreenConversationErrors,
    ThrowOnError
  >({
    url: '/prescreen/conversation/release',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List published jobs (public)
 */
export const listPublicJobs = <ThrowOnError extends boolean = false>(
  options?: Options<ListPublicJobsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListPublicJobsResponses,
    ListPublicJobsErrors,
    ThrowOnError
  >({ url: '/job-portal/jobs', ...options });

/**
 * Get a published job (public)
 */
export const getPublicJob = <ThrowOnError extends boolean = false>(
  options: Options<GetPublicJobData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPublicJobResponses,
    GetPublicJobErrors,
    ThrowOnError
  >({ url: '/job-portal/jobs/get', ...options });

/**
 * Minimal pre-auth login-screen context for a job (works for unpublished invite-only jobs)
 */
export const getJobLoginContext = <ThrowOnError extends boolean = false>(
  options: Options<GetJobLoginContextData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetJobLoginContextResponses,
    GetJobLoginContextErrors,
    ThrowOnError
  >({ url: '/job-portal/jobs/login-context', ...options });

/**
 * List published jobs with candidate annotations (authenticated)
 */
export const listMyJobs = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyJobsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListMyJobsResponses,
    ListMyJobsErrors,
    ThrowOnError
  >({ url: '/job-portal/my-jobs', ...options });

/**
 * Get a published job with full candidate detail (authenticated)
 */
export const getMyJob = <ThrowOnError extends boolean = false>(
  options: Options<GetMyJobData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetMyJobResponses,
    GetMyJobErrors,
    ThrowOnError
  >({ url: '/job-portal/my-jobs/get', ...options });

/**
 * Get custom application questions and own answers for a job (authenticated)
 */
export const getApplicationQuestions = <ThrowOnError extends boolean = false>(
  options: Options<GetApplicationQuestionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetApplicationQuestionsResponses,
    GetApplicationQuestionsErrors,
    ThrowOnError
  >({ url: '/job-portal/applications/questions', ...options });

/**
 * Submit answers to a job's custom application questions (candidate)
 */
export const submitApplicationAnswers = <ThrowOnError extends boolean = false>(
  options: Options<SubmitApplicationAnswersData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SubmitApplicationAnswersResponses,
    SubmitApplicationAnswersErrors,
    ThrowOnError
  >({
    url: '/job-portal/applications/answer-questions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Upload or replace own profile photo for a job's photo question (candidate, multipart)
 */
export const uploadApplicationPhoto = <ThrowOnError extends boolean = false>(
  options: Options<UploadApplicationPhotoData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadApplicationPhotoResponses,
    UploadApplicationPhotoErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/job-portal/applications/upload-photo',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Delete own application (candidate)
 */
export const deleteApplicationCandidate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteApplicationCandidateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    DeleteApplicationCandidateResponses,
    DeleteApplicationCandidateErrors,
    ThrowOnError
  >({
    url: '/job-portal/application/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Accept privacy policy for own application (candidate)
 */
export const acceptPrivacyPolicy = <ThrowOnError extends boolean = false>(
  options: Options<AcceptPrivacyPolicyData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AcceptPrivacyPolicyResponses,
    AcceptPrivacyPolicyErrors,
    ThrowOnError
  >({
    url: '/job-portal/application/accept-privacy-policy',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Apply for a job — optional multipart resume upload
 */
export const applyForJob = <ThrowOnError extends boolean = false>(
  options: Options<ApplyForJobData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ApplyForJobResponses,
    ApplyForJobErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/job-portal/applications/apply',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Upload a resume for an existing application (multipart)
 */
export const uploadResumeForApplication = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UploadResumeForApplicationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UploadResumeForApplicationResponses,
    UploadResumeForApplicationErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/job-portal/applications/upload-resume',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Get interview details for the candidate taking the interview
 *
 * Returns the meeting-critical interview payload for the authenticated candidate. Fails with 403 if the authenticated user does not own this interview. Includes a 2-hour signed GCS URL for the candidate's resume.
 */
export const getCandidateInterview = <ThrowOnError extends boolean = false>(
  options: Options<GetCandidateInterviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCandidateInterviewResponses,
    GetCandidateInterviewErrors,
    ThrowOnError
  >({ url: '/interviews/candidate/get', ...options });

/**
 * Send one message to the case study chat assistant
 *
 * Streams the assistant's reply as plain text, a fragment at a time. Fails with 403 if the authenticated user does not own this interview, and with 429 once the per-user rate limit is hit. Both sides of the turn are recorded before and after the model call, so the transcript survives a dropped request.
 */
export const sendCaseStudyChatMessage = <ThrowOnError extends boolean = false>(
  options: Options<SendCaseStudyChatMessageData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SendCaseStudyChatMessageResponses,
    SendCaseStudyChatMessageErrors,
    ThrowOnError
  >({
    url: '/interviews/candidate/case-study-chat',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Log a batch of camera-bitrate readings for the connection-quality feature
 *
 * Logs bitrate readings to BigQuery only, REC-2321 PR1 makes no pause or kick decision from this data yet. Fails with 403 if the authenticated user does not own this interview, and with 429 once the per-user rate limit is hit. A dropped write never affects the interview, telemetry is fail-open.
 */
export const recordConnectionQuality = <ThrowOnError extends boolean = false>(
  options: Options<RecordConnectionQualityData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RecordConnectionQualityResponses,
    RecordConnectionQualityErrors,
    ThrowOnError
  >({
    url: '/interviews/candidate/connection-quality',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List all interviews for the authenticated candidate
 *
 * Returns all interviews belonging to the authenticated user across all tenants. Pass ?lockdown_browser_only=true to restrict to jobs with lockdown browser enabled (used by the desktop client). This query is intentionally cross-tenant: the desktop lockdown browser authenticates via the central auth subdomain, not the candidate's employer subdomain, so tenant filtering would silently return empty results for those clients.
 */
export const listMyInterviews = <ThrowOnError extends boolean = false>(
  options?: Options<ListMyInterviewsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListMyInterviewsResponses,
    ListMyInterviewsErrors,
    ThrowOnError
  >({ url: '/interviews/candidate/mine', ...options });

/**
 * Get interview details for a recruiter
 *
 * Returns the full interview detail for a recruiter, including candidate PII, the synthesized scorecard (criteria mapped from TOML evaluation_criteria), and a 2-hour signed GCS URL for the candidate's resume. Fails with 403 if the caller is not a tenant member.
 */
export const getRecruiterInterview = <ThrowOnError extends boolean = false>(
  options: Options<GetRecruiterInterviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetRecruiterInterviewResponses,
    GetRecruiterInterviewErrors,
    ThrowOnError
  >({ url: '/interviews/recruiter/get', ...options });

/**
 * List interviews for a job (recruiter view)
 *
 * Returns a cursor-paginated list of interviews for the given job. Requires recruiter, hiring_manager, or Account Admin role. Pass ?tab= to filter by evaluation state. Pass ?intake_filters[batch]=<value> to filter by the batch field in intake metadata.
 */
export const listInterviewsForJob = <ThrowOnError extends boolean = false>(
  options: Options<ListInterviewsForJobData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListInterviewsForJobResponses,
    ListInterviewsForJobErrors,
    ThrowOnError
  >({ url: '/interviews', ...options });

/**
 * Get interview result (session auth or share token)
 *
 * Two mutually exclusive access modes: pass `interview_id` for session-authenticated access (recruiter or candidate), or pass `token` for public share-link access. Exactly one must be provided.
 */
export const getInterviewResult = <ThrowOnError extends boolean = false>(
  options?: Options<GetInterviewResultData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetInterviewResultResponses,
    GetInterviewResultErrors,
    ThrowOnError
  >({ url: '/interviews/result', ...options });

/**
 * Sign one proctoring clip URL on demand (session auth or share token)
 *
 * Returns a short-lived signed URL for a single proctoring clip, signed on demand when the clip modal opens (clips are no longer signed at result-assembly time). Same access modes as get_interview_result: `interview_id`/`application_id` for session auth, or `token` for a public share link. A clip withheld from the result payload (disputed on a public share, or proctoring hidden) returns `clip_url=null`, as does a missing clip.
 */
export const getProctoringClipUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetProctoringClipUrlData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProctoringClipUrlResponses,
    GetProctoringClipUrlErrors,
    ThrowOnError
  >({ url: '/interviews/proctoring-clip-url', ...options });

/**
 * Generate a public share link for an interview result
 */
export const generateInterviewShareToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GenerateInterviewShareTokenData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GenerateInterviewShareTokenResponses,
    GenerateInterviewShareTokenErrors,
    ThrowOnError
  >({
    url: '/interviews/share-token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Recruiter records feedback on a proctoring flag (agree or disagree) and re-buckets the candidate
 */
export const recordProctoringFeedback = <ThrowOnError extends boolean = false>(
  options: Options<RecordProctoringFeedbackData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RecordProctoringFeedbackResponses,
    RecordProctoringFeedbackErrors,
    ThrowOnError
  >({
    url: '/interviews/{interview_id}/proctoring-flags/feedback',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List available tests (jobs) for Greenhouse
 *
 * Returns active jobs as partner tests. Authentication: HMAC Basic Auth.
 */
export const greenhouseListTests = <ThrowOnError extends boolean = false>(
  options?: Options<GreenhouseListTestsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GreenhouseListTestsResponses,
    GreenhouseListTestsErrors,
    ThrowOnError
  >({ url: '/greenhouse/list_tests', ...options });

/**
 * Get interview status
 *
 * Returns partner status and results for a given interview ID. Greenhouse polls this.
 */
export const greenhouseTestStatus = <ThrowOnError extends boolean = false>(
  options: Options<GreenhouseTestStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GreenhouseTestStatusResponses,
    GreenhouseTestStatusErrors,
    ThrowOnError
  >({ url: '/greenhouse/test_status', ...options });

/**
 * Send candidate to assessment
 *
 * Creates user, application, and interview for a Greenhouse candidate. Queues invitation email.
 */
export const greenhouseSendTest = <ThrowOnError extends boolean = false>(
  options: Options<GreenhouseSendTestData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GreenhouseSendTestResponses,
    GreenhouseSendTestErrors,
    ThrowOnError
  >({
    url: '/greenhouse/send_test',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Log errors from Greenhouse
 *
 * Receives error reports from Greenhouse. Logs and returns 200.
 */
export const greenhouseRequestErrors = <ThrowOnError extends boolean = false>(
  options: Options<GreenhouseRequestErrorsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GreenhouseRequestErrorsResponses,
    GreenhouseRequestErrorsErrors,
    ThrowOnError
  >({
    url: '/greenhouse/request_errors',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Read-only: which of the supplied emails already have an active interview for this job
 */
export const checkAlreadyInSystem = <ThrowOnError extends boolean = false>(
  options: Options<CheckAlreadyInSystemData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CheckAlreadyInSystemResponses,
    CheckAlreadyInSystemErrors,
    ThrowOnError
  >({
    url: '/candidate-intake/check-already-in-system',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Poll status + progress of an in-flight or completed validation task
 */
export const getCandidateIntakeValidationStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCandidateIntakeValidationStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCandidateIntakeValidationStatusResponses,
    GetCandidateIntakeValidationStatusErrors,
    ThrowOnError
  >({ url: '/candidate-intake/validation-status', ...options });

/**
 * Bulk-create screening-stage applications for a job
 */
export const bulkScreeningIntake = <ThrowOnError extends boolean = false>(
  options: Options<BulkScreeningIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BulkScreeningIntakeResponses,
    BulkScreeningIntakeErrors,
    ThrowOnError
  >({
    url: '/candidate-intake/bulk-screening',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk-create interview-stage applications + Interview rows for a job
 */
export const bulkInterviewIntake = <ThrowOnError extends boolean = false>(
  options: Options<BulkInterviewIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BulkInterviewIntakeResponses,
    BulkInterviewIntakeErrors,
    ThrowOnError
  >({
    url: '/candidate-intake/bulk-interview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Move RESUME_SCREENING applications to INTERVIEWING and optionally fire invite emails
 */
export const inviteToInterview = <ThrowOnError extends boolean = false>(
  options: Options<InviteToInterviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InviteToInterviewResponses,
    InviteToInterviewErrors,
    ThrowOnError
  >({
    url: '/candidate-intake/invite-to-interview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Move CREATED applications to INVITED_FOR_ASSESSMENT and optionally fire invite emails
 */
export const inviteToAssessment = <ThrowOnError extends boolean = false>(
  options: Options<InviteToAssessmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    InviteToAssessmentResponses,
    InviteToAssessmentErrors,
    ThrowOnError
  >({
    url: '/candidate-intake/invite-to-assessment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk-create assessment-stage applications for a job (create + invite, skipping screening)
 */
export const bulkAssessmentIntake = <ThrowOnError extends boolean = false>(
  options: Options<BulkAssessmentIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    BulkAssessmentIntakeResponses,
    BulkAssessmentIntakeErrors,
    ThrowOnError
  >({
    url: '/candidate-intake/bulk-assessment',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create one screening-stage application for a job (multipart: request JSON + optional resume file)
 */
export const singleScreeningIntake = <ThrowOnError extends boolean = false>(
  options: Options<SingleScreeningIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SingleScreeningIntakeResponses,
    SingleScreeningIntakeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/candidate-intake/single-screening',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Create one interview-stage application + Interview row for a job (multipart: request JSON + optional resume file)
 */
export const singleInterviewIntake = <ThrowOnError extends boolean = false>(
  options: Options<SingleInterviewIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SingleInterviewIntakeResponses,
    SingleInterviewIntakeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/candidate-intake/single-interview',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Create one assessment-stage application for a job (multipart: request JSON + optional resume file)
 */
export const singleAssessmentIntake = <ThrowOnError extends boolean = false>(
  options: Options<SingleAssessmentIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SingleAssessmentIntakeResponses,
    SingleAssessmentIntakeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/candidate-intake/single-assessment',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Create one candidate and add them to the job's copilot round (multipart: request JSON + resume file, required unless one is on file)
 */
export const singleCopilotIntake = <ThrowOnError extends boolean = false>(
  options: Options<SingleCopilotIntakeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SingleCopilotIntakeResponses,
    SingleCopilotIntakeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/candidate-intake/single-copilot',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Kick off async validation of a candidate-intake spreadsheet or resume ZIP
 */
export const startCandidateIntakeValidation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<StartCandidateIntakeValidationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartCandidateIntakeValidationResponses,
    StartCandidateIntakeValidationErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/candidate-intake/start-validation',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Parse a single PDF/DOCX resume into structured candidate fields
 */
export const parseCandidateResume = <ThrowOnError extends boolean = false>(
  options: Options<ParseCandidateResumeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ParseCandidateResumeResponses,
    ParseCandidateResumeErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: '/candidate-intake/parse-resume',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

/**
 * Comprehensive analytics for a job
 */
export const getJobAnalytics = <ThrowOnError extends boolean = false>(
  options: Options<GetJobAnalyticsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetJobAnalyticsResponses,
    GetJobAnalyticsErrors,
    ThrowOnError
  >({ url: '/analytics/comprehensive', ...options });

/**
 * Distinct batch values for the job filter dropdown
 */
export const getJobAnalyticsBatches = <ThrowOnError extends boolean = false>(
  options: Options<GetJobAnalyticsBatchesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetJobAnalyticsBatchesResponses,
    GetJobAnalyticsBatchesErrors,
    ThrowOnError
  >({ url: '/analytics/batches', ...options });

/**
 * Download analytics as a multi-sheet Excel workbook
 */
export const getJobAnalyticsExcel = <ThrowOnError extends boolean = false>(
  options: Options<GetJobAnalyticsExcelData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetJobAnalyticsExcelResponses,
    GetJobAnalyticsExcelErrors,
    ThrowOnError
  >({ url: '/analytics/excel', ...options });

/**
 * Download tenant consumption report
 */
export const getConsumptionReport = <ThrowOnError extends boolean = false>(
  options?: Options<GetConsumptionReportData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetConsumptionReportResponses,
    GetConsumptionReportErrors,
    ThrowOnError
  >({ url: '/analytics/consumption', ...options });

/**
 * Get consumption analytics for the tenant
 */
export const getUsageAnalytics = <ThrowOnError extends boolean = false>(
  options?: Options<GetUsageAnalyticsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetUsageAnalyticsResponses,
    GetUsageAnalyticsErrors,
    ThrowOnError
  >({ url: '/usage-analytics', ...options });

/**
 * The job's email templates, without bodies
 */
export const listEmailTemplates = <ThrowOnError extends boolean = false>(
  options: Options<ListEmailTemplatesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListEmailTemplatesResponses,
    ListEmailTemplatesErrors,
    ThrowOnError
  >({ url: '/email-templates', ...options });

/**
 * One email template with its subject and bodies
 */
export const getEmailTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GetEmailTemplateData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetEmailTemplateResponses,
    GetEmailTemplateErrors,
    ThrowOnError
  >({ url: '/email-templates/get', ...options });

/**
 * The variables a trigger's template may use, with example values for this job
 */
export const getEmailTemplateVariables = <ThrowOnError extends boolean = false>(
  options: Options<GetEmailTemplateVariablesData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetEmailTemplateVariablesResponses,
    GetEmailTemplateVariablesErrors,
    ThrowOnError
  >({ url: '/email-templates/variables', ...options });

/**
 * Emails sent for the job, a page of them plus counts over the same filters
 */
export const searchSentEmails = <ThrowOnError extends boolean = false>(
  options: Options<SearchSentEmailsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SearchSentEmailsResponses,
    SearchSentEmailsErrors,
    ThrowOnError
  >({ url: '/email-templates/sent-emails', ...options });

/**
 * Save a template's subject, body or settings
 */
export const updateEmailTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateEmailTemplateData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateEmailTemplateResponses,
    UpdateEmailTemplateErrors,
    ThrowOnError
  >({
    url: '/email-templates/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Send the saved template, filled with example values, to one address
 */
export const sendTestEmail = <ThrowOnError extends boolean = false>(
  options: Options<SendTestEmailData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SendTestEmailResponses,
    SendTestEmailErrors,
    ThrowOnError
  >({
    url: '/email-templates/test-email',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Ask for delivery statuses to be pulled now
 */
export const refreshSentEmails = <ThrowOnError extends boolean = false>(
  options: Options<RefreshSentEmailsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RefreshSentEmailsResponses,
    RefreshSentEmailsErrors,
    ThrowOnError
  >({
    url: '/email-templates/sent-emails/refresh',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Generate a short-lived JWT for Inkeep agents-api authentication
 *
 * Returns a 30-minute HS256 JWT signed with the platform secret key. The Inkeep agents-api verifies this token (via DJANGO_SECRET_KEY env var) to authenticate support-chat requests without a session cookie proxy.
 */
export const generateInkeepToken = <ThrowOnError extends boolean = false>(
  options?: Options<GenerateInkeepTokenData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GenerateInkeepTokenResponses,
    GenerateInkeepTokenErrors,
    ThrowOnError
  >({ url: '/inkeep/token', ...options });

/**
 * Execute Task
 */
export const executeTaskTasksExecutePost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ExecuteTaskTasksExecutePostData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    ExecuteTaskTasksExecutePostResponses,
    ExecuteTaskTasksExecutePostErrors,
    ThrowOnError
  >({
    url: '/tasks/execute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Read a partner API credential by key id
 *
 * Same as reading by credential id, addressed by the key's public half. After a leak the artifact in hand is the key itself, not the credential id that was printed once at creation.
 */
export const getPartnerCredentialByKeyId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPartnerCredentialByKeyIdData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPartnerCredentialByKeyIdResponses,
    GetPartnerCredentialByKeyIdErrors,
    ThrowOnError
  >({ url: '/partner-credentials/by-key-id/{key_id}', ...options });

/**
 * Read a partner API credential
 *
 * Identity and lifecycle state for one credential. Never returns secret material — the API key exists only in the response that created it.
 */
export const getPartnerCredential = <ThrowOnError extends boolean = false>(
  options: Options<GetPartnerCredentialData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetPartnerCredentialResponses,
    GetPartnerCredentialErrors,
    ThrowOnError
  >({ url: '/partner-credentials/{credential_id}', ...options });

/**
 * Provision a partner API credential
 *
 * Creates the service account, role and membership if absent, then mints a key. Idempotent.
 */
export const createPartnerCredential = <ThrowOnError extends boolean = false>(
  options: Options<CreatePartnerCredentialData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreatePartnerCredentialResponses,
    CreatePartnerCredentialErrors,
    ThrowOnError
  >({
    url: '/partner-credentials',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Revoke a partner API credential by key id
 *
 * The incident path: revoke straight from the leaked key's public half, without first looking up its credential id. Idempotent, like revoking by id.
 */
export const revokePartnerCredentialByKeyId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RevokePartnerCredentialByKeyIdData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RevokePartnerCredentialByKeyIdResponses,
    RevokePartnerCredentialByKeyIdErrors,
    ThrowOnError
  >({ url: '/partner-credentials/by-key-id/{key_id}/revoke', ...options });

/**
 * Revoke a partner API credential
 *
 * Retires the key immediately; the next request presenting it gets 401. Idempotent — revoking an already-revoked credential succeeds and reports `revoked_now: false`. The service account and its membership are left in place, so a replacement key can be minted without re-provisioning them.
 */
export const revokePartnerCredential = <ThrowOnError extends boolean = false>(
  options: Options<RevokePartnerCredentialData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RevokePartnerCredentialResponses,
    RevokePartnerCredentialErrors,
    ThrowOnError
  >({ url: '/partner-credentials/{credential_id}/revoke', ...options });

/**
 * Update a partner credential's webhook by key id
 *
 * Change the webhook URL, signing secret or auth token in place, addressed by the key's public half. Partial: fields left out are untouched.
 */
export const updatePartnerCredentialWebhookByKeyId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePartnerCredentialWebhookByKeyIdData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdatePartnerCredentialWebhookByKeyIdResponses,
    UpdatePartnerCredentialWebhookByKeyIdErrors,
    ThrowOnError
  >({
    url: '/partner-credentials/by-key-id/{key_id}/webhook',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update a partner credential's webhook
 *
 * Change the webhook URL, signing secret or auth token in place, without revoking and re-minting the key. Partial: a field left out keeps its current value. A supplied URL is re-validated before it is stored.
 */
export const updatePartnerCredentialWebhook = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdatePartnerCredentialWebhookData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdatePartnerCredentialWebhookResponses,
    UpdatePartnerCredentialWebhookErrors,
    ThrowOnError
  >({
    url: '/partner-credentials/{credential_id}/webhook',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Available Events
 */
export const getWorkflowAvailableEvents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetWorkflowAvailableEventsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWorkflowAvailableEventsResponses,
    GetWorkflowAvailableEventsErrors,
    ThrowOnError
  >({ url: '/workflow/available-events', ...options });

/**
 * Get Audit History
 */
export const getWorkflowAuditHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowAuditHistoryData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetWorkflowAuditHistoryResponses,
    GetWorkflowAuditHistoryErrors,
    ThrowOnError
  >({ url: '/workflow/audit-history', ...options });

/**
 * The unreviewed AI rejects rated below a threshold that Reject below would confirm
 */
export const workflowRejectBelowPreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WorkflowRejectBelowPreviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    WorkflowRejectBelowPreviewResponses,
    WorkflowRejectBelowPreviewErrors,
    ThrowOnError
  >({ url: '/workflow/reject-below-preview', ...options });

/**
 * Get Bulk Available Events
 */
export const getWorkflowBulkAvailableEvents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetWorkflowBulkAvailableEventsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    GetWorkflowBulkAvailableEventsResponses,
    GetWorkflowBulkAvailableEventsErrors,
    ThrowOnError
  >({
    url: '/workflow/bulk-available-events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Transition
 */
export const workflowTransition = <ThrowOnError extends boolean = false>(
  options: Options<WorkflowTransitionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowTransitionResponses,
    WorkflowTransitionErrors,
    ThrowOnError
  >({
    url: '/workflow/transition',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Transition
 */
export const workflowBulkTransition = <ThrowOnError extends boolean = false>(
  options: Options<WorkflowBulkTransitionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowBulkTransitionResponses,
    WorkflowBulkTransitionErrors,
    ThrowOnError
  >({
    url: '/workflow/bulk-transition',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Submit Human Review
 */
export const workflowSubmitHumanReview = <ThrowOnError extends boolean = false>(
  options: Options<WorkflowSubmitHumanReviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowSubmitHumanReviewResponses,
    WorkflowSubmitHumanReviewErrors,
    ThrowOnError
  >({
    url: '/workflow/submit-human-review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Confirm the AI's Reject for every unreviewed candidate rated below a threshold
 */
export const workflowBulkRejectBelow = <ThrowOnError extends boolean = false>(
  options: Options<WorkflowBulkRejectBelowData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowBulkRejectBelowResponses,
    WorkflowBulkRejectBelowErrors,
    ThrowOnError
  >({
    url: '/workflow/bulk-reject-below',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Assign Reviewer
 */
export const workflowAssignReviewer = <ThrowOnError extends boolean = false>(
  options: Options<WorkflowAssignReviewerData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowAssignReviewerResponses,
    WorkflowAssignReviewerErrors,
    ThrowOnError
  >({
    url: '/workflow/assign-reviewer',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Assign Reviewer
 */
export const workflowBulkAssignReviewer = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WorkflowBulkAssignReviewerData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowBulkAssignReviewerResponses,
    WorkflowBulkAssignReviewerErrors,
    ThrowOnError
  >({
    url: '/workflow/bulk-assign-reviewer',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Assign By Added By
 */
export const workflowBulkAssignByAddedBy = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WorkflowBulkAssignByAddedByData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowBulkAssignByAddedByResponses,
    WorkflowBulkAssignByAddedByErrors,
    ThrowOnError
  >({
    url: '/workflow/bulk-assign-by-added-by',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Send Reminder
 */
export const workflowBulkSendReminder = <ThrowOnError extends boolean = false>(
  options: Options<WorkflowBulkSendReminderData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowBulkSendReminderResponses,
    WorkflowBulkSendReminderErrors,
    ThrowOnError
  >({
    url: '/workflow/bulk-send-reminder',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Reminder Preview
 */
export const workflowReminderPreview = <ThrowOnError extends boolean = false>(
  options: Options<WorkflowReminderPreviewData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowReminderPreviewResponses,
    WorkflowReminderPreviewErrors,
    ThrowOnError
  >({
    url: '/workflow/reminder-preview',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Change Deadline
 */
export const workflowBulkChangeDeadline = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WorkflowBulkChangeDeadlineData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowBulkChangeDeadlineResponses,
    WorkflowBulkChangeDeadlineErrors,
    ThrowOnError
  >({
    url: '/workflow/bulk-change-deadline',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Bulk Change Assessment Deadline
 */
export const workflowBulkChangeAssessmentDeadline = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WorkflowBulkChangeAssessmentDeadlineData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    WorkflowBulkChangeAssessmentDeadlineResponses,
    WorkflowBulkChangeAssessmentDeadlineErrors,
    ThrowOnError
  >({
    url: '/workflow/bulk-change-assessment-deadline',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Assessment Preview
 */
export const getCodingAssessmentPreview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCodingAssessmentPreviewData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCodingAssessmentPreviewResponses,
    GetCodingAssessmentPreviewErrors,
    ThrowOnError
  >({ url: '/coding-assessments/{assessment_id}/preview', ...options });

/**
 * Start Assessment
 */
export const startCodingAssessment = <ThrowOnError extends boolean = false>(
  options: Options<StartCodingAssessmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    StartCodingAssessmentResponses,
    StartCodingAssessmentErrors,
    ThrowOnError
  >({ url: '/coding-assessments/{assessment_id}/start', ...options });

/**
 * Start the candidate's clock at the moment the editor appears, not at /start
 */
export const markCodingAssessmentEditorLoaded = <
  ThrowOnError extends boolean = false,
>(
  options: Options<MarkCodingAssessmentEditorLoadedData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    MarkCodingAssessmentEditorLoadedResponses,
    MarkCodingAssessmentEditorLoadedErrors,
    ThrowOnError
  >({ url: '/coding-assessments/{assessment_id}/editor-loaded', ...options });

/**
 * Sync Draft
 */
export const syncCodingAssessmentDraft = <ThrowOnError extends boolean = false>(
  options: Options<SyncCodingAssessmentDraftData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SyncCodingAssessmentDraftResponses,
    SyncCodingAssessmentDraftErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/problems/{problem_id}/sync',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Run Code
 */
export const runCodingAssessmentCode = <ThrowOnError extends boolean = false>(
  options: Options<RunCodingAssessmentCodeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RunCodingAssessmentCodeResponses,
    RunCodingAssessmentCodeErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/problems/{problem_id}/run',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Submit Code
 */
export const submitCodingAssessmentCode = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SubmitCodingAssessmentCodeData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    SubmitCodingAssessmentCodeResponses,
    SubmitCodingAssessmentCodeErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/problems/{problem_id}/submit',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Execution Status
 */
export const getCodingAssessmentExecutionStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCodingAssessmentExecutionStatusData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCodingAssessmentExecutionStatusResponses,
    GetCodingAssessmentExecutionStatusErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/executions/{execution_id}/status',
    ...options,
  });

/**
 * List Submissions
 */
export const listCodingAssessmentSubmissions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListCodingAssessmentSubmissionsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    ListCodingAssessmentSubmissionsResponses,
    ListCodingAssessmentSubmissionsErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/problems/{problem_id}/submissions',
    ...options,
  });

/**
 * Serve a diagram the problem statement references, to its candidate or a recruiter on the job
 */
export const getCodingAssessmentProblemAsset = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCodingAssessmentProblemAssetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetCodingAssessmentProblemAssetResponses,
    GetCodingAssessmentProblemAssetErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/problems/{problem_id}/assets/{filename}',
    ...options,
  });

/**
 * Complete Assessment
 */
export const completeCodingAssessment = <ThrowOnError extends boolean = false>(
  options: Options<CompleteCodingAssessmentData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CompleteCodingAssessmentResponses,
    CompleteCodingAssessmentErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/{assessment_id}/complete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Batch-ingest candidate-emitted proctoring events (behavioral signals + real-time violations)
 */
export const recordCodingAssessmentEvents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RecordCodingAssessmentEventsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RecordCodingAssessmentEventsResponses,
    RecordCodingAssessmentEventsErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/{assessment_id}/events',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Create Recording Session
 */
export const createCodingAssessmentRecordingSession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CreateCodingAssessmentRecordingSessionData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateCodingAssessmentRecordingSessionResponses,
    CreateCodingAssessmentRecordingSessionErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/{assessment_id}/recording-session',
    ...options,
  });

/**
 * List assessment-round applications for a job, or one application in full when application_id is given
 */
export const getAssessmentApplications = <ThrowOnError extends boolean = false>(
  options: Options<GetAssessmentApplicationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAssessmentApplicationsResponses,
    GetAssessmentApplicationsErrors,
    ThrowOnError
  >({ url: '/coding-assessments/applications', ...options });

/**
 * One coding assessment attempt in full, keyed by the attempt id the review page is addressed by
 */
export const getAssessmentAttempt = <ThrowOnError extends boolean = false>(
  options: Options<GetAssessmentAttemptData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAssessmentAttemptResponses,
    GetAssessmentAttemptErrors,
    ThrowOnError
  >({ url: '/coding-assessments/attempts/{assessment_id}', ...options });

/**
 * Signed recording for one attempt; separate from the detail read because the storage lookup is slow
 */
export const getAssessmentAttemptRecordingUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetAssessmentAttemptRecordingUrlData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAssessmentAttemptRecordingUrlResponses,
    GetAssessmentAttemptRecordingUrlErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/attempts/{assessment_id}/recording-url',
    ...options,
  });

/**
 * Signed recording for one application (single camera url or multi-track manifest); separate from detail because the storage lookup is slow
 */
export const getAssessmentRecordingUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetAssessmentRecordingUrlData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAssessmentRecordingUrlResponses,
    GetAssessmentRecordingUrlErrors,
    ThrowOnError
  >({ url: '/coding-assessments/applications/recording-url', ...options });

/**
 * Get the recruiter-configured assessment template for a job, if any
 */
export const getAssessmentConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetAssessmentConfigData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetAssessmentConfigResponses,
    GetAssessmentConfigErrors,
    ThrowOnError
  >({ url: '/coding-assessments/config', ...options });

/**
 * Save the recruiter-configured assessment template for a job
 */
export const saveAssessmentConfig = <ThrowOnError extends boolean = false>(
  options: Options<SaveAssessmentConfigData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    SaveAssessmentConfigResponses,
    SaveAssessmentConfigErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/config',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Suggest a first assessment design from the job description, unsaved
 */
export const suggestAssessmentDesign = <ThrowOnError extends boolean = false>(
  options: Options<SuggestAssessmentDesignData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    SuggestAssessmentDesignResponses,
    SuggestAssessmentDesignErrors,
    ThrowOnError
  >({ url: '/coding-assessments/suggested-design', ...options });

/**
 * List the topics a problem slot can draw from at one difficulty, with pool sizes
 */
export const getProblemTopics = <ThrowOnError extends boolean = false>(
  options: Options<GetProblemTopicsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProblemTopicsResponses,
    GetProblemTopicsErrors,
    ThrowOnError
  >({ url: '/coding-assessments/problem-topics', ...options });

/**
 * Run the candidate draw against an unsaved design and return the problems it dealt
 */
export const previewSampleProblems = <ThrowOnError extends boolean = false>(
  options: Options<PreviewSampleProblemsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PreviewSampleProblemsResponses,
    PreviewSampleProblemsErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/problem-samples',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Serve a diagram in a previewed problem statement, to a recruiter on the job
 */
export const getProblemBankAsset = <ThrowOnError extends boolean = false>(
  options: Options<GetProblemBankAssetData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetProblemBankAssetResponses,
    GetProblemBankAssetErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/problem-bank/{problem_id}/assets/{filename}',
    ...options,
  });

/**
 * Set the coding assessment's live proctoring toggles for a job
 */
export const updateAssessmentLiveProctoring = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAssessmentLiveProctoringData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateAssessmentLiveProctoringResponses,
    UpdateAssessmentLiveProctoringErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/update-live-proctoring',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Replace the pre-assessment instructions a candidate sees before starting
 */
export const updateAssessmentInstructions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAssessmentInstructionsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateAssessmentInstructionsResponses,
    UpdateAssessmentInstructionsErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/update-instructions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Turn post-assessment AI proctoring on or off for a job
 */
export const updateAssessmentAiProctoring = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateAssessmentAiProctoringData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    UpdateAssessmentAiProctoringResponses,
    UpdateAssessmentAiProctoringErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/update-ai-proctoring',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Save what the recruiter wants this round to reflect
 */
export const saveAssessmentRequirements = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SaveAssessmentRequirementsData, ThrowOnError>,
) =>
  (options.client ?? client).put<
    SaveAssessmentRequirementsResponses,
    SaveAssessmentRequirementsErrors,
    ThrowOnError
  >({
    url: '/coding-assessments/requirements',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Read one assessment result with a share token instead of a session
 *
 * The assessment counterpart of the interview share link. The assessment is identified by the token, not by a parameter: a tampered or expired token is rejected before any row is read.
 */
export const getSharedAssessmentResult = <ThrowOnError extends boolean = false>(
  options: Options<GetSharedAssessmentResultData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSharedAssessmentResultResponses,
    GetSharedAssessmentResultErrors,
    ThrowOnError
  >({ url: '/coding-assessments/shared/result', ...options });

/**
 * Signed recording for a share-token holder; separate from the result for the same slow-lookup reason
 */
export const getSharedAssessmentRecordingUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSharedAssessmentRecordingUrlData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetSharedAssessmentRecordingUrlResponses,
    GetSharedAssessmentRecordingUrlErrors,
    ThrowOnError
  >({ url: '/coding-assessments/shared/recording-url', ...options });

/**
 * Get the authenticated caller's identity
 *
 * Returns the authenticated user's {id, name, email} resolved from the request principal (no DB read). Replaces the legacy `/api/users/?search=<email>` self-lookup.
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(
  options?: Options<GetCurrentUserData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetCurrentUserResponses,
    GetCurrentUserErrors,
    ThrowOnError
  >({ url: '/users/me', ...options });

/**
 * Update the authenticated caller's name
 *
 * Sets the caller's own first and last name. The target is always the request principal, so the body carries no user id. Replaces the pair: omitting `last_name` clears it.
 */
export const updateCurrentUser = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCurrentUserData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateCurrentUserResponses,
    UpdateCurrentUserErrors,
    ThrowOnError
  >({
    url: '/users/me',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Record the caller's acceptance of the Terms / Privacy Policy
 *
 * Stamps the authenticated caller's consent to the given terms version. The target is always the request principal, so the body carries no user id. Idempotent per version.
 */
export const acceptTerms = <ThrowOnError extends boolean = false>(
  options: Options<AcceptTermsData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    AcceptTermsResponses,
    AcceptTermsErrors,
    ThrowOnError
  >({
    url: '/users/accept-terms',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * V2 Health
 */
export const v2HealthHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<V2HealthHealthGetData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    V2HealthHealthGetResponses,
    unknown,
    ThrowOnError
  >({ url: '/health', ...options });
